const talukasByState = {
  "Andhra Pradesh": {
    "Anantapur": [
      "Agali",
      "Amarapuram",
      "Amudagur",
      "Anantapur",
      "Bommanahal",
      "Brahmasamudram",
      "Chennekothapalli",
      "Dharmavaram",
      "Didigur",
      "Garladinne",
      "Gooty",
      "Gummagatta",
      "Guntakal",
      "Hindupur",
      "Kadiri",
      "Kalyandurg",
      "Kambadur",
      "Kothacheruvu",
      "Kundurpi",
      "Lepakshi",
      "Madakasira",
      "Mudigubba",
      "Nallacheruvu",
      "Nambulipulikunta",
      "Obuladevaracheruvu",
      "Pamidi",
      "Parigi",
      "Peddapappur",
      "Penukonda",
      "Puttaparthi",
      "Rayadurg",
      "Rolla",
      "Settur",
      "Singanamala",
      "Somandepalli",
      "Tadimarri",
      "Tadipatri",
      "Talipaluru",
      "Uravakonda",
      "Vidapanakal"
    ],
    "Chittoor": [
      "Baireddipalle",
      "Bangarupalem",
      "Chittoor",
      "Gangadhara Nellore",
      "Gudipala",
      "Gudupalle",
      "Irala",
      "K.V.Palle",
      "Kuppam",
      "Nagari",
      "Nindra",
      "Palamaner",
      "Palasamudram",
      "Penumuru",
      "Pileru",
      "Punganur",
      "Puttur",
      "Ramachandrapuram",
      "Rompicherla",
      "Santhipuram",
      "Satyavedu",
      "Sodam",
      "Srikalahasti",
      "Thavanampalle",
      "Tirupati",
      "Vadamalapeta",
      "Valmikipuram",
      "Vedurukuppam",
      "Yerpedu",
      "Yerravaripalem"
    ],
    "East Godavari": [
      "Addateegala",
      "Ainavilli",
      "Alamuru",
      "Amalapuram",
      "Ambajipeta",
      "Anaparthi",
      "Atreyapuram",
      "Devipatnam",
      "Gangavaram",
      "Gannavaram",
      "Gokavaram",
      "I.Polavaram",
      "Jaggampeta",
      "Kadiam",
      "Kajuluru",
      "Kakinada",
      "Karapa",
      "Katrenikona",
      "Kirlampudi",
      "Korukonda",
      "Kothapeta",
      "Malkipuram",
      "Mandapeta",
      "Mummidivaram",
      "Pamarru",
      "Pedapudi",
      "Peddapuram",
      "Pithapuram",
      "Prathipadu",
      "Rajanagaram",
      "Rajavommangi",
      "Rajahmundry",
      "Ramachandrapuram",
      "Rampachodavaram",
      "Rayavaram",
      "Sakhinetipalle",
      "Seethanagaram",
      "Tallarevu",
      "Thallapudi",
      "Tuni",
      "Yeleswaram"
    ],
    "Guntur": [
      "Achampeta",
      "Amaravathi",
      "Atchampet",
      "Bellamkonda",
      "Bollapalle",
      "Chebrolu",
      "Chilakaluripet",
      "Dachepalle",
      "Duggirala",
      "Edlapadu",
      "Guntur",
      "Gurazala",
      "Ipuru",
      "Kollipara",
      "Krosuru",
      "Macherla",
      "Machavaram",
      "Mangalagiri",
      "Medikonduru",
      "Muppalla",
      "Nadendla",
      "Narasaraopet",
      "Nekarikallu",
      "Nuzendla",
      "Pedakakani",
      "Pedakurapadu",
      "Phirangipuram",
      "Pittalavanipalem",
      "Prathipadu",
      "Rajupalem",
      "Repalle",
      "Sattenapalle",
      "Tadikonda",
      "Tadepalli",
      "Tenali",
      "Thullur",
      "Tsundur",
      "Vatticherukuru",
      "Veldurthi",
      "Vinukonda"
    ],
    "Krishna": [
      "Agiripalle",
      "Avanigadda",
      "Bantumilli",
      "Challapalli",
      "Chandarlapadu",
      "Gampalagudem",
      "Gannavaram",
      "Ghantasala",
      "Gudivada",
      "Gudlavalleru",
      "Ibrahimpatnam",
      "Jaggaiahpet",
      "Kaikalur",
      "Kalidindi",
      "Kanchikacherla",
      "Koduru",
      "Kruthivennu",
      "Machilipatnam",
      "Mopidevi",
      "Movva",
      "Mudinepalli",
      "Mylavaram",
      "Nagayalanka",
      "Nandigama",
      "Nuzvid",
      "Pamidimukkala",
      "Pamarru",
      "Pedana",
      "Reddigudem",
      "Thotlavalluru",
      "Tiruvuru",
      "Unguturu",
      "Vatsavai",
      "Veerullapadu",
      "Vijayawada",
      "Vissannapeta",
      "Vuyyuru"
    ],
    "Kurnool": [
      "Adoni",
      "Alur",
      "Allagadda",
      "Aspari",
      "Atmakur",
      "Banaganapalle",
      "Bethamcherla",
      "C.Belagal",
      "Chippagiri",
      "Devaragattu",
      "Dhone",
      "Gadivemula",
      "Gonegandla",
      "Guduru",
      "Halaharvi",
      "Holagunda",
      "Jupadu Bungalow",
      "Kallur",
      "Kodumur",
      "Kowthalam",
      "Kurnool",
      "Krishnagiri",
      "Maddikera(East)",
      "Mantralayam",
      "Midthur",
      "Nandavaram",
      "Nandikotkur",
      "Nandyal",
      "Orvakal",
      "Owk",
      "Pagidyal",
      "Panyam",
      "Pathikonda",
      "Pattikonda",
      "Peapally",
      "Pulicherla",
      "Srisailam",
      "Tuggali",
      "Uyyalawada",
      "Veldurthi",
      "Yemmiganur"
    ],
    "Prakasam": [
      "Addanki",
      "Ballikurava",
      "Bestavaripeta",
      "ChandraSekharaPuram",
      "Chimakurthi",
      "Chirala",
      "Cumbum",
      "Darshi",
      "Darsi",
      "Donakonda",
      "Dornala",
      "Giddalur",
      "Gollaprolu",
      "Gudluru",
      "HanumanthuniPadu",
      "Jarugumalli",
      "Kambham",
      "Kanigiri",
      "Kandukur",
      "Karamchedu",
      "Komarolu",
      "Kondapi",
      "Korisapadu",
      "Kurichedu",
      "Maddipadu",
      "Markapur",
      "Martur",
      "Mundlamuru",
      "Naguluppalapadu",
      "Ongole",
      "Parchur",
      "Pedacherlopalle",
      "Podili",
      "Pullalacheruvu",
      "Racherla",
      "Santhanuthalapadu",
      "Singarayakonda",
      "Tangutur",
      "Tarlupadu",
      "Tripuranthakam",
      "Ulavapalle",
      "Veligandla",
      "Yerragondapalem"
    ],
    "Srikakulam": [
      "Amadalavalasa",
      "Bhamini",
      "Burja",
      "Etcherla",
      "Hiramandalam",
      "Ichchapuram",
      "Jalumuru",
      "Kanchili",
      "Kaviti",
      "Kotabommali",
      "Kothuru",
      "Lakshminarsupeta",
      "Laveru",
      "Mandasa",
      "Meliaputti",
      "Nandigam",
      "Narasannapeta",
      "Palasa",
      "Pathapatnam",
      "Ponduru",
      "Rajam",
      "Ranastalam",
      "Saravakota",
      "Sarubujjili",
      "Seethampeta",
      "Sompeta",
      "Srikakulam",
      "Tekkali",
      "Vajrapukotturu"
    ],
    "Visakhapatnam": [
      "Anakapalli",
      "Anandapuram",
      "Atchutapuram",
      "Bheemunipatnam",
      "Butchayyapeta",
      "Chodavaram",
      "Devarapalle",
      "Gajuwaka",
      "Gangaraju Madugula",
      "Kasimkota",
      "K Kotapadu",
      "Madugula",
      "Makavarapalem",
      "Munagapaka",
      "Nakkapalle",
      "Narsipatnam",
      "Padmanabham",
      "Paravada",
      "Payakaraopeta",
      "Pendurthi",
      "Rambilli",
      "Ravikamatham",
      "Sabbavaram",
      "S Rayavaram",
      "Visakhapatnam",
      "Yelamanchili"
    ],
    "Vizianagaram": [
      "Badangi",
      "Bobbili",
      "Bondili",
      "Cheepurupalli",
      "Dattirajeru",
      "Gajapathinagaram",
      "Garividi",
      "Gumma Lakshmipuram",
      "Jami",
      "Komarada",
      "Kothavalasa",
      "Kurupam",
      "Lakkavarapukota",
      "Mentada",
      "Merakamudidam",
      "Nellimarla",
      "Pachipenta",
      "Parvathipuram",
      "Salur",
      "Srungavarapukota",
      "Therlam",
      "Vizianagaram"
    ],
    "West Godavari": [
      "Akividu",
      "Bhimavaram",
      "Buttayagudem",
      "Chintalapudi",
      "Denduluru",
      "Devipatnam",
      "Dwaraka Tirumala",
      "Eluru",
      "Ganapavaram",
      "Gopalapuram",
      "Jangareddygudem",
      "Jeelugu Milli",
      "Kaikaram",
      "Kamavarapukota",
      "Kovvur",
      "Kukunoor",
      "Nallajerla",
      "Narasapuram",
      "Nidadavole",
      "Nuzvid",
      "Pedavegi",
      "Peddapadu",
      "Polavaram",
      "Tadepalligudem",
      "Tallapudi",
      "Undi",
      "Unguturu"
    ]
  },
  "Arunachal Pradesh": {
    "Anjaw": ["Anjaw", "Hayuliang", "Manchal"],
    "Changlang": ["Bordumsa", "Changlang", "Kharsang", "Miao", "Vijaynagar"],
    "East Kameng": ["Bameng", "Khenewa", "Lada", "Pipirang", "Seppa"],
    "East Siang": ["Mebo", "Pasighat", "Ruksin"],
    "Kra Daadi": ["Nyapin", "Palin"],
    "Kurung Kumey": ["Damin", "Koloriang", "Nyapin"],
    "Lepa Rada": ["Basar", "Dari", "Jini", "Sago"],
    "Lohit": ["Chowkham", "Namsai", "Tezu", "Wakro"],
    "Lower Dibang Valley": ["Dambuk", "Roing"],
    "Lower Siang": [
      "Basar",
      "Daring",
      "Kambang",
      "Kangku",
      "Likabali",
      "Liromoba",
      "Nari-Koyu",
      "Rumgong"
    ],
    "Longding": ["Kanubari", "Longding", "Pongchau", "Wakka"],
    "Namsai": ["Lekang", "Namsai"],
    "Pakke-Kessang": ["Pakke-Kessang", "Seijosa"],
    "Papum Pare": ["Balijan", "Doimukh", "Kimim", "Sagalee", "Yupia"],
    "Shi Yomi": ["Mechuka", "Tato"],
    "Siang": ["Boleng", "Pangin", "Rumgong"],
    "Tawang": ["Jang", "Lumla", "Tawang"],
    "Tirap": [
      "Borduria",
      "Dadam",
      "Khonsa",
      "Lazu",
      "Namsang",
      "Pongchao",
      "Wakka"
    ],
    "Upper Dibang Valley": ["Anini", "Koronu", "Mipi"],
    "Upper Siang": ["Gelling", "Mariyang", "Tuting", "Yingkiong"],
    "West Kameng": ["Bomdila", "Dirang", "Kalaktang", "Rupa", "Thrizino"],
    "West Siang": ["Along", "Basar", "Liromoba", "Mechuka"]
  },
  "Assam": {
    "Baksa": ["Baksa", "Tamulpur"],
    "Barpeta": ["Barpeta", "Bhabanipur", "Kalgachia", "Sarthebari"],
    "Biswanath": ["Biswanath Chariali", "Gohpur", "Halem"],
    "Bongaigaon": ["Bijni", "Boitamari", "Bongaigaon"],
    "Cachar": ["Lakhipur", "Silchar", "Sonai"],
    "Charaideo": ["Mahmora", "Sapekhati", "Sonari"],
    "Chirang": ["Bijni", "Kajalgaon"],
    "Darrang": ["Dalgaon", "Mangaldoi", "Sipajhar"],
    "Dhemaji": ["Dhemaji", "Jonai", "Sissiborgaon"],
    "Dhubri": ["Bilashipara", "Dhubri", "Gauripur", "Golokganj"],
    "Dibrugarh": ["Chabua", "Dibrugarh", "Naharkatia", "Tingkhong"],
    "Dima Hasao": ["Haflong", "Maibang", "Umrangso"],
    "Goalpara": ["Balijana", "Dudhnoi", "Goalpara", "Lakhipur"],
    "Golaghat": ["Bokakhat", "Dergaon", "Golaghat", "Khumtai", "Sarupathar"],
    "Hailakandi": ["Hailakandi", "Katlicherra", "Lala"],
    "Hojai": ["Doboka", "Hojai", "Lanka"],
    "Jorhat": ["Jorhat", "Mariani", "Titabor"],
    "Kamrup Metropolitan": ["Guwahati"],
    "Kamrup Rural": ["Amingaon", "Chaygaon", "Hajo", "Kamalpur", "Rani"],
    "Karbi Anglong": [
      "Bakalia",
      "Diphu",
      "Donkamokam",
      "Hamren",
      "Howraghat"
    ],
    "Karimganj": ["Badarpur", "Karimganj", "Patharkandi", "Ramkrishnanagar"],
    "Kokrajhar": ["Dotma", "Gossaigaon", "Kokrajhar", "Parbatjhora"],
    "Lakhimpur": ["Bihpuria", "Dhakuakhana", "Narayanpur", "North Lakhimpur"],
    "Majuli": ["Majuli"],
    "Morigaon": ["Jagiroad", "Mayong", "Morigaon"],
    "Nagaon": ["Dhing", "Kaliabor", "Kampur", "Nagaon", "Raha", "Samaguri"],
    "Nalbari": ["Barkhetri", "Nalbari", "Tihu"],
    "Sivasagar": ["Amguri", "Nazira", "Sivasagar", "Sonari"],
    "Sonitpur": [
      "Biswanath Chariali",
      "Dhekiajuli",
      "Gohpur",
      "Tezpur"
    ],
    "South Salmara-Mankachar": ["Hatsingimari", "Mankachar", "Salmara"],
    "Tinsukia": ["Digboi", "Doomdooma", "Margherita", "Sadiya", "Tinsukia"],
    "Udalguri": ["Kalaigaon", "Mazbat", "Paneri", "Udalguri"],
    "West Karbi Anglong": ["Donkamokam", "Hamren", "Kheroni"]
  },
  "Bihar": {
    "Araria": ["Araria", "Forbesganj", "Sikti", "Raniganj", "Jokihat", "Kursakanta", "Palasi", "Bhargama", "Narpatganj"],
    "Arwal": ["Arwal", "Kurtha", "Kaler", "Karpi", "Sonbhadra"],
    "Aurangabad": ["Aurangabad", "Rafiganj", "Goh", "Obra", "Haspura", "Deo", "Madanpur", "Kutumba", "Nabinagar", "Barun", "Amarpura"],
    "Banka": ["Banka", "Amarpur", "Dhoraiya", "Katoria", "Chandan", "Belhar", "Phulia Dummer", "Rajaun", "Bausi", "Barahat", "Sambhuganj"],
    "Begusarai": ["Begusarai", "Sahebpur Kamal", "Matihani", "Teghra", "Mansi", "Cheria Bariarpur", "Samho", "Khodabandpur", "Bachhwara", "Dandari", "Bakhri", "Barauni", "Birpur", "Khudabandpur", "Bhagwanpur"],
    "Bhagalpur": ["Bhagalpur", "Nathnagar", "Gopalpur", "Naugachia", "Kharik", "Parbatta", "Sultanganj", "Shahkund", "Dhura Muraar", "Sanhaula", "Pirpainti", "Kahalgaon", "Sabour", "Jagdishpur", "Ekchari"],
    "Bhojpur": ["Arrah", "Jagdispur", "Piro", "Sahar", "Sandesh", "Barhara", "Koilwar", "Tarari", "Udwantnagar", "Charpokhari", "Agiaon", "Garhani", "Bihiya", "Shahpur"],
    "Buxar": ["Buxar", "Dumraon", "Rajpur", "Chausa", "Chakiya", "Itarhi", "Simri", "Brahmapur", "Kesath", "Nawanagar", "Murar"],
    "Darbhanga": ["Darbhanga", "Benipur", "Hayaghat", "Bahadurpur", "Kalyanpur", "Keotiranway", "Jale", "Kiratpur", "Singhwara", "Manigachhi", "Alinagar", "Ghanshyampur", "Baheri", " Тардих"],
    "Gaya": ["Gaya", "Bodh Gaya", "Manpur", "Mohanpur", "Atri", "Belaganj", "Khizarsarai", "Paraiya", "Wazirganj", "Imamganj", "Dumaria", "Barachatti", "Tekari", "Gurua", "Kurwa", "Fatehpur", "Tankuppa", "Ambedkar Nagar"],
    "Gopalganj": ["Gopalganj", "Kuchaikote", "Bhorey", "Thawe", "Kateya", "Manjha", "Sidhwaliya", "Baikunthpur", "Barharia", "Siwan", "Hathua", "Phulwaria", "Uchkagaon", "Vijayipur"],
    "Jamui": ["Jamui", "Taraurhi", "Sikandra", "Laxmipur", "Khaira", "Gidhaur", "Sono", "Jhajha", "Chakai", "Barhat"],
    "Jehanabad": ["Jehanabad", "Makhdumpur", "Ghoshi", "Kako", "Modanganj", "Hulasganj", "Kurtha"],
    "Kaimur": ["Bhabua", "Mohania", "Ramgarh", "Nuaon", "Chainpur", "Chand", "Adhaura", "Bhagwanpur", "Durgawati", "Kudra", "Kochas"],
    "Katihar": ["Katihar", "Barari", "Kursela", "Korha", "Sameli", "Falka", "Pranpur", "Dandkhora", "Hasanpur", "Kadwa", "Azamnagar", "Manihari", "Amour", "Barsoi", "Balrampur", "Purnia"],
    "Khagaria": ["Khagaria", "Alauli", "Beldaur", "Chautham", "Mansi", "Parbatta", "Gogri", "Sherbela"],
    "Kishanganj": ["Kishanganj", "Thakurganj", "Pothia", "Bahadurganj", "Dighalbank", "Kochadhaman", "Terhagachh", "Dighalbank"],
    "Lakhisarai": ["Lakhisarai", "Barahiya", "Surajgarha", "Halsi", "Pipariya", "Ramgarh Chowk", "Girish Nagar"],
    "Madhepura": ["Madhepura", "Murliganj", "Singheshwar", "Alamnagar", "Bihariganj", "Gwalpara", "Kumarkhand", "Shankarpur", "Puraini", "Salkhua", "Gamharia", " Chausa"],
    "Madhubani": ["Madhubani", "Benipatti", "Rajnagar", "Jhanjharpur", "Laukahi", "Laukaha", "Phulparas", "Khajauli", "Jaynagar", "Basopatti", "Andhratharhi", "Babubarhi", "Bisahul", "Ladania", "Tamuria", "Pandaul", "Kaluahi", "Harlakhi", " Basopatti"],
    "Munger": ["Munger", "Jamalpur", "Bariarpur", "Dharhara", "Kharagpur", "Sangrampur", "Tarapur", "Tetia Bambar", "Asarganj", "Haveli Kharagpur"],
    "Muzaffarpur": ["Muzaffarpur", "Kurhani", "Sakara", "Muraul", "Mushahari", "Kanti", "Saraiya", "Sahebganj", "Paroo", "Motipur", "Sakra", "Bandra", " Bochaha", " Gayaghat"],
    "Nalanda": ["Bihar Sharif", "Rajgir", "Islampur", "Hilsa", "Chandi", "Ekangarsarai", "Rahui", "Parwalpur", "Noorsarai", "Katarisarai", "Asthawan", "Sarmera", "Karahparshurai", "Ben", "Bind", "Silao", "Nagar Nausa", "Therthari", " Harnaut"],
    "Nawada": ["Nawada", "Pakribarawan", "Rajauli", "Gobindpur", "Hisua", "Warsaliganj", "Kashichak", "Meskaur", "Akbarpur", "Roh", " Narhat", " Sirdala"],
    "Pashchim Champaran": ["Bettiah", "Chanpatia", "Bairiya", "Nautan", "Sikta", "Mainatand", "Bagaha", "Ramnagar", "Gaunaha", "Thakahan", "Madhuban", "Kesariya", " Kalyanpur"],
    "Patna": ["Patna", "Phulwari Sharif", "Danapur", "Masaudhi", "Paliganj", "Dulhin Bazar", "Bikram", "Naubatpur", "Bihta", "Maner", "Sampatchak", "Fatuha", "Daniyawan", "Hilsa", "Pandarakh", "Athmalgola", "Bakhtiarpur", "Barh", "Mokama", "Ghoswari", " Barh"],
    "Purbi Champaran": ["Motihari", "Chakaiya", "Pipra Kothi", " Kalyanpur", " Areraj", " Govindganj", " Kesariya", " Kotwa", " Pakridayal", " Sangrampur", " Mehsi", " Tetaria", " Dhaka", " Chiraiya", " Raxaul", " Ramgarhwa", " Bankatwa", " Adapur", " Chhauradano", " Ghorasahan", " Patahi", " Phenahara"],
    "Purnia": ["Purnia", "Kasba", "Banmankhi", "Rupauli", "Dagarua", "Krityanand Nagar", "Baisa", "Amour", "BhawaniPur", "Srinagar", "Jalalgarh", "Pipra", "Dhamdaha", "Barhara Kothi"],
    "Rohtas": ["Sasaram", "Dehri", "Karakat", "Nasriganj", "Nokha", "Sanjhauli", "Bikramganj", "Dinara", "Sivsagar", "Sheosagar", "Chenari", "Rohtas", "Agorer", "Kargahar", "Kochas", "Tilouthu", "Akodhi", "Narayangarh", " Suryapura"],
    "Saharsa": ["Saharsa", "Salkhua", "Sattar Kataiya", "Mahishi", "Tarhi", "Kahra", "Simri Bakhtiarpur", "Sour Bazar", "Patarghat", "Sonbarsa", "Banma Itahari"],
    "Samastipur": ["Samastipur", "Pusa", "Tajpur", " Kalyanpur", " Warisnagar", "Mohanpur", "Sarairanjan", "Dalsingsarai", "Ujiarpur", "Vidyapatinagar", "Bibhutipur", "Rosera", "Singhia", "Hasanpur", "Bibhutipur", "Shivaji Nagar", "Khanpur", "Patori", "Mohiuddinagar", "Morwa"],
    "Saran": ["Chhapra", "Sonepur", "Dighwara", "Manjhi", "Revelganj", "Parsa", "Amnour", "Taraiya", "Marhaura", "Ekma", "Jalalpur", " Madhaura", " Garkha", " Dariyapur", " Jalalpur", " Isuapur", " Manjhi", " Parsa"],
    "Sheikhpura": ["Sheikhpura", "Barbigha", "Ariari", "Chewara", "Ghat Kusumbha", "Korari"],
    "Sheohar": ["Sheohar", "Piprarhi", "Tariyani", "Dubaipatti", "Purnahiya"],
    "Sitamarhi": ["Sitamarhi", "Belsand", " Parihar", " Sursand", " Bajpatti", " Pupri", " Bokhra", " Runnisaidpur", " Riga", " Nanpur", " Sonbarsa", " Dumra", " Majorganj", " Suppi", " Katra", " Benipur"],
    "Siwan": ["Siwan", "Mairwa", "Guthani", " Darauli", " Ekouna", " Siswan", " Andar", " Barharia", " HussainGanj", " Maharajganj", " Hasanpura", " Bhagwanpur Hat", " Lakri Nabiganj", " Nautan", " Raghunathpur", " Basantpur", " Bhagwanpur Hat"],
    "Supaul": ["Supaul", "Piparahi", "Sariswa", "Kishanpur", "Raghopur", "Basantpur", "Pratapganj", "Supaul", "Tribeniganj", "Chhatapur", "Nirmali", "Marauna", "Koilimpur"],
    "Vaishali": ["Hajipur", "Mahnar", "Raghopur", " Chero", " Desari", " Mahua", " Patedhi Belsar", " Patepur", " Sahdei", " Vaishali", " Rajapakar", " Jandaha", " Goraul", " Bhagwanpur", " Lalganj", " Patedhi"]
  },
  "Chhattisgarh": {
    "Balod": [
      "Balod",
      "Dilli Rajhara",
      "Dondi",
      "Dondi Lohara",
      "Gunderdehi",
      "Gurur"
    ],
    "Baloda Bazar": [
      "Baloda Bazar",
      "Bhatapara",
      "Bilaigarh",
      "Kasdol",
      "Palari",
      "Simga"
    ],
    "Balrampur": [
      "Balrampur",
      "Kusmi",
      "Ramanujganj",
      "Ramchandrapur",
      "Rajpur",
      "Samri",
      "Shankargarh",
      "Wadrafnagar"
    ],
    "Bastar": [
      "Bakanur",
      "Bakawand",
      "Bastar",
      "Darba",
      "Jagdalpur",
      "Lohandiguda",
      "Tokapal"
    ],
    "Bemetara": [
      "Bemetara",
      "Dhamdha",
      "Nawagarh",
      "Saja",
      "Thanakhamria"
    ],
    "Bijapur": [
      "Awapalli",
      "Bhairamgarh",
      "Bijapur",
      "Usur"
    ],
    "Bilaspur": [
      "Bilha",
      "Bodri",
      "Bilaspur",
      "Kota",
      "Masturi",
      "Sipat",
      "Takhatpur"
    ],
    "Dantewada": [
      "Dantewada",
      "Gidam",
      "Katekalyan",
      "Kuakonda"
    ],
    "Dhamtari": [
      "Dhamtari",
      "Kurud",
      "Magarlod",
      "Nagri"
    ],
    "Durg": [
      "Bhilai",
      "Dhamdha",
      "Durg",
      "Patan"
    ],
    "Gariaband": [
      "Chhura",
      "Deobhog",
      "Gariaband",
      "Mainpur",
      "Rajim"
    ],
    "Gaurela-Pendra-Marwahi": [
      "Gaurela",
      "Marwahi",
      "Pendra"
    ],
    "Janjgir-Champa": [
      "Akaltara",
      "Bamhnidih",
      "Champa",
      "Dabhra",
      "Jaijaipur",
      "Janjgir",
      "Kharsia",
      "Malkharoda",
      "Nawagarh",
      "Sakti"
    ],
    "Jashpur": [
      "Bagicha",
      "Duldula",
      "Jashpur",
      "Kansabel",
      "Kunkuri",
      "Manora",
      "Pathalgaon",
      "Pharsabahar"
    ],
    "Kabirdham": [
      "Bodla",
      "Kawardha",
      "Pandariya",
      "Sahaspur Lohara"
    ],
    "Kanker": [
      "Antagarh",
      "Bhanupratappur",
      "Charama",
      "Durgkondal",
      "Kanker",
      "Koyalibeda",
      "Narharpur"
    ],
    "Kondagaon": [
      "Bade Rajpur",
      "Faraspal",
      "Keskal",
      "Kondagaon",
      "Makdi",
      "Pharasgaon"
    ],
    "Korba": [
      "Kartala",
      "Katghora",
      "Korba",
      "Pali",
      "Pondi Uproda"
    ],
    "Koriya": [
      "Baikunthpur",
      "Bharatpur",
      "Chirmiri",
      "Khadgawan",
      "Manendragarh",
      "Sonhat"
    ],
    "Mahasamund": [
      "Bagbahra",
      "Basna",
      "Mahasamund",
      "Pithora",
      "Saraipali"
    ],
    "Mungeli": [
      "Lormi",
      "Mungeli",
      "Pathariya"
    ],
    "Narayanpur": [
      "Narayanpur",
      "Orchha"
    ],
    "Raigarh": [
      "Baramkela",
      "Dharamjaigarh",
      "Gharghoda",
      "Kharsia",
      "Lailunga",
      "Pusaur",
      "Raigarh",
      "Sarangarh",
      "Tamnar"
    ],
    "Raipur": [
      "Abhanpur",
      "Arang",
      "Dharsiwa",
      "Gariaband",
      "Kharora",
      "Mana Camp",
      "Raipur",
      "Tilda"
    ],
    "Rajnandgaon": [
      "Ambagarh Chowki",
      "Chhuikhadan",
      "Chhuriya",
      "Dongargaon",
      "Dongargarh",
      "Khairagarh",
      "Manpur",
      "Mohla",
      "Rajnandgaon"
    ],
    "Sukma": [
      "Chhindgarh",
      "Dornapal",
      "Konta",
      "Sukma"
    ],
    "Surajpur": [
      "Bhaiyathan",
      "Odagi",
      "Pratappur",
      "Premnagar",
      "Ramanujnagar",
      "Surajpur"
    ],
    "Surguja": [
      "Ambikapur",
      "Batouli",
      "Lakhhanpur",
      "Lundra",
      "Mainpat",
      "Sitapur",
      "Udaipur"
    ]
  },
  "Chandigarh": {
    "Chandigarh": ["Chandigarh"]
  },
  "Delhi": {
    "Central Delhi": ["Darya Ganj", "Paharganj", "Karol Bagh"],
    "East Delhi": ["Gandhi Nagar", "Preet Vihar", "Mayur Vihar"],
    "New Delhi": ["Chanakyapuri", "Connaught Place"],
    "North Delhi": ["Sadar Bazar", "Kotwali", "Civil Lines"],
    "North East Delhi": ["Seelampur", "Shahdara"],
    "North West Delhi": ["Narela", "Model Town"],
    "South Delhi": ["Hauz Khas", "Mehrauli", "Saket"],
    "South West Delhi": ["Dwarka", "Najafgarh", "Kapashera"],
    "West Delhi": ["Punjabi Bagh", "Rajouri Garden", "Patel Nagar"]
  },
  "Dadra and Nagar Haveli": {
    "Dadra and Nagar Haveli": ["Dadra", "Silvassa"]
  },
  "Goa": {
    "North Goa": ["Bardez", "Tiswadi", "Pernem", "Bicholim", "Satari", "Ponda"],
    "South Goa": ["Salcete", "Mormugao", "Quepem", "Canacona", "Sanguem", "Dharbandora"]
  },
  "Gujarat": {
    "Ahmedabad": [
      "Ahmedabad City",
      "Bavla",
      "Daskroi",
      "Detroj-Rampura",
      "Dhandhuka",
      "Mandal",
      "Sanand",
      "Viramgam"
    ],
    "Amreli": [
      "Amreli",
      "Bagasara",
      "Chalala",
      "Jafrabad",
      "Khambha",
      "Kunkavav-Vadia",
      "Lathi",
      "Lilia",
      "Rajula",
      "Savarkundla"
    ],
    "Anand": [
      "Anand",
      "Anklav",
      "Borsad",
      "Khambhat",
      "Petlad",
      "Sojitra",
      "Tarapur",
      "Umreth",
      "Vallabh Vidyanagar"
    ],
    "Aravalli": [
      "Bayad",
      "Bhiloda",
      "Dhansura",
      "Malpur",
      "Meghraj",
      "Modasa"
    ],
    "Banaskantha": [
      "Amirgadh",
      "Bhabhar",
      "Danta",
      "Dantiwada",
      "Deesa",
      "Deodar",
      "Dhanera",
      "Kankrej",
      "Lakhani",
      "Palanpur",
      "Sami",
      "Santalpur",
      "Suigam",
      "Tharad",
      "Vadgam",
      "Vadali"
    ],
    "Bharuch": [
      "Amod",
      "Ankleshwar",
      "Bharuch",
      "Hansot",
      "Jambusar",
      "Jhagadia",
      "Netrang",
      "Vagra",
      "Valia"
    ],
    "Bhavnagar": [
      "Bhavnagar",
      "Gariadhar",
      "Ghogho",
      "Jesar",
      "Kundla",
      "Mahuva",
      "Palitana",
      "Sihor",
      "Talaja",
      "Umrala",
      "Vallabhipur"
    ],
    "Botad": [
      "Barvala",
      "Botad",
      "Gadhada",
      "Ranpur"
    ],
    "Chhota Udaipur": [
      "Chhota Udaipur",
      "Jetpur Pavi",
      "Kavant",
      "Naswadi",
      "Sankheda"
    ],
    "Dahod": [
      "Dahod",
      "Devgadbaria",
      "Fatepura",
      "Garbada",
      "Jhalod",
      "Limkheda",
      "Sanjeli",
      "Santrampur"
    ],
    "Devbhumi Dwarka": [
      "Bhanvad",
      "Dwarka",
      "Kalyanpur",
      "Khambhalia",
      "Okhamandal"
    ],
    "Gandhinagar": [
      "Dahegam",
      "Gandhinagar",
      "Kalol",
      "Mansa"
    ],
    "Gir Somnath": [
      "Gir Gadhada",
      "Kodinar",
      "Prabhas Patan",
      "Sutrapada",
      "Talala",
      "Una",
      "Veraval"
    ],
    "Jamnagar": [
      "Dhrol",
      "Jamjodhpur",
      "Jamnagar",
      "Jodiya",
      "Kalavad",
      "Lalpur"
    ],
    "Junagadh": [
      "Bhesan",
      "Junagadh",
      "Keshod",
      "Maliya Hatina",
      "Manavadar",
      "Mangrol",
      "Mendarda",
      "Vanthali",
      "Visavadar"
    ],
    "Kheda": [
      "Galteshwar",
      "Kapadvanj",
      "Kathlal",
      "Kheda",
      "Mahudha",
      "Matar",
      "Mehmedabad",
      "Nadiad",
      "Thasra",
      "Vaso"
    ],
    "Kutch": [
      "Abdasa",
      "Anjar",
      "Bhachau",
      "Bhuj",
      "Dhaneti",
      "Gandhidham",
      "Lakhpat",
      "Mandvi",
      "Mundra",
      "Nakhatrana",
      "Rapar"
    ],
    "Mahisagar": [
      "Balasinor",
      "Kadana",
      "Khanpur",
      "Lunawada",
      "Santrampur",
      "Virpur"
    ],
    "Mehsana": [
      "Becharaji",
      "Chanasma",
      "Harij",
      "Jotana",
      "Kheralu",
      "Mehsana",
      "Satlasana",
      "Unjha",
      "Vadnagar",
      "Vijapur",
      "Visnagar"
    ],
    "Morbi": [
      "Dhrangadhra",
      "Halvad",
      "Maliya",
      "Morbi",
      "Tankara",
      "Wankaner"
    ],
    "Narmada": [
      "Dediapada",
      "Garudeshwar",
      "Nandod",
      "Rajpipla",
      "Sagbara",
      "Tilakwada"
    ],
    "Navsari": [
      "Chikhli",
      "Gandevi",
      "Jalalpore",
      "Khergam",
      "Navsari",
      "Vansda"
    ],
    "Panchmahal": [
      "Ghoghamba",
      "Godhra",
      "Halol",
      "Jambughoda",
      "Kalol",
      "Morwa Hadaf",
      "Shehera"
    ],
    "Patan": [
      "Chanasma",
      "Harij",
      "Patan",
      "Radhanpur",
      "Sami",
      "Santalpur",
      "Saraswati",
      "Sidhpur"
    ],
    "Porbandar": [
      "Kutiyana",
      "Porbandar",
      "Ranavav"
    ],
    "Rajkot": [
      "Dhoraji",
      "Gondal",
      "Jamkandorana",
      "Jasdan",
      "Jetpur",
      "Kotda Sangani",
      "Lodhika",
      "Paddhari",
      "Rajkot",
      "Upleta",
      "Vinchhiya"
    ],
    "Sabarkantha": [
      "Bhiloda",
      "Himatnagar",
      "Idar",
      "Khedbrahma",
      "Malpur",
      "Meghraj",
      "Poshina",
      "Prantij",
      "Talod",
      "Vadali",
      "Vijaynagar"
    ],
    "Surat": [
      "Bardoli",
      "Choryasi",
      "Kamrej",
      "Mahuva",
      "Mandvi",
      "Mangrol",
      "Olpad",
      "Palsana",
      "Surat City",
      "Umarpada"
    ],
    "Surendranagar": [
      "Chotila",
      "Dasada",
      "Dhrangadhra",
      "Halvad",
      "Lakhtar",
      "Limbdi",
      "Muli",
      "Sayla",
      "Surendranagar",
      "Thangadh",
      "Wadhwan"
    ],
    "Tapi": [
      "Dolvan",
      "Kukarmunda",
      "Nizar",
      "Songadh",
      "Uchchhal",
      "Valod",
      "Vyara"
    ],
    "Vadodara": [
      "Dabhoi",
      "Desar",
      "Karjan",
      "Padra",
      "Savli",
      "Shinor",
      "Vadodara",
      "Vadodara City",
      "Waghodia"
    ],
    "Valsad": [
      "Dharampur",
      "Kaprada",
      "Paradi",
      "Pardi",
      "Umbergaon",
      "Valsad"
    ]
  },
  "Haryana": {
    "Ambala": [
      "Ambala",
      "Ambala Cantt",
      "Barara",
      "Naraingarh"
    ],
    "Bhiwani": [
      "Bawani Khera",
      "Bhiwani",
      "Dadri",
      "Kairu",
      "Loharu",
      "Siwani"
    ],
    "Charkhi Dadri": [
      "Badhra",
      "Charkhi Dadri"
    ],
    "Faridabad": [
      "Ballabgarh",
      "Faridabad",
      "Tigaon"
    ],
    "Fatehabad": [
      "Fatehabad",
      "Ratia",
      "Tohana"
    ],
    "Gurgaon": [
      "Farrukhnagar",
      "Gurgaon",
      "Manesar",
      "Pataudi",
      "Sohna"
    ],
    "Hisar": [
      "Adampur",
      "Barwala",
      "Hansi",
      "Hisar",
      "Narnaund",
      "Uklana"
    ],
    "Jhajjar": [
      "Bahadurgarh",
      "Beri",
      "Jhajjar",
      "Matanhail"
    ],
    "Jind": [
      "Alewa",
      "Jind",
      "Narwana",
      "Safidon",
      "Uchana"
    ],
    "Kaithal": [
      "Guhla",
      "Kalayat",
      "Kaithal",
      "Pundri"
    ],
    "Karnal": [
      "Assandh",
      "Gharaunda",
      "Indri",
      "Karnal",
      "Nilokheri"
    ],
    "Kurukshetra": [
      "Kurukshetra",
      "Pehowa",
      "Shahbad",
      "Thanesar"
    ],
    "Mahendragarh": [
      "Ateli",
      "Kanina",
      "Mahendragarh",
      "Narnaul"
    ],
    "Mewat": [
      "Ferozepur Jhirka",
      "Hathin",
      "Nuh",
      "Punhana",
      "Taoru"
    ],
    "Palwal": [
      "Hasanpur",
      "Hathin",
      "Hodal",
      "Palwal"
    ],
    "Panchkula": [
      "Barwala",
      "Kalka",
      "Panchkula",
      "Raipur Rani"
    ],
    "Panipat": [
      "Bapauli",
      "Israna",
      "Panipat",
      "Samalkha"
    ],
    "Rewari": [
      "Bawal",
      "Kosli",
      "Nahal",
      "Rewari"
    ],
    "Rohtak": [
      "Kalanaur",
      "Lakhan Majra",
      "Meham",
      "Rohtak",
      "Sampla"
    ],
    "Sirsa": [
      "Dabwali",
      "Ellenabad",
      "Kalanwali",
      "Rania",
      "Sirsa"
    ],
    "Sonipat": [
      "Gohana",
      "Kharkhoda",
      "Rai",
      "Sonipat"
    ],
    "Yamunanagar": [
      "Bilaspur",
      "Chhachhrauli",
      "Jagadhri",
      "Yamunanagar"
    ]
  },
  "Himachal Pradesh": {
    "Bilaspur": [
      "Barmana",
      "Bilaspur",
      "Ghumarwin",
      "Jhandutta",
      "Naina Devi",
      "Sri Naina Devi Ji"
    ],
    "Chamba": [
      "Bhattiyat",
      "Chamba",
      "Churah",
      "Dalhousie",
      "Pangi",
      "Salooni",
      "Tissa"
    ],
    "Hamirpur": [
      "Barsar",
      "Bhoranj",
      "Hamirpur",
      "Nadaun",
      "Sujanpur"
    ],
    "Kangra": [
      "Baijnath",
      "Bailta",
      "Baroh",
      "Dehra Gopipur",
      "Dharamsala",
      "Fatehpur",
      "Indora",
      "Jaisinghpur",
      "Jaswan",
      "Kangra",
      "Khundian",
      "Kotla",
      "Multhan",
      "Nurpur",
      "Palampur"
    ],
    "Kinnaur": [
      "Kalpa",
      "Nichar",
      "Pooh",
      "Reckong Peo",
      "Sangla"
    ],
    "Kullu": [
      "Anni",
      "Banjar",
      "Kullu",
      "Naggar",
      "Sainj"
    ],
    "Lahaul and Spiti": [
      "Kaza",
      "Keylong",
      "Udaipur"
    ],
    "Mandi": [
      "Balh",
      "Bali Chowki",
      "Chachyot",
      "Dharampur",
      "Joginder Nagar",
      "Karsog",
      "Lad Bharol",
      "Mandi",
      "Nihri",
      "Padhar",
      "Sarkaghat",
      "Seraj",
      "Sundarnagar",
      "Thunag"
    ],
    "Shimla": [
      "Chirgaon",
      "Chopal",
      "Dodra Kwar",
      "Jubbal",
      "Kotkhai",
      "Kumarsain",
      "Nankhari",
      "Narkanda",
      "Rampur Bushahr",
      "Rohru",
      "Shimla",
      "Theog"
    ],
    "Sirmaur": [
      "Nahan",
      "Paonta Sahib",
      "Rajgarh",
      "Renukaji",
      "Sangrah",
      "Shillai"
    ],
    "Solan": [
      "Arki",
      "Kandaghat",
      "Kasauli",
      "Nalagarh",
      "Solan"
    ],
    "Una": [
      "Amb",
      "Bangana",
      "Bharwain",
      "Gagret",
      "Haroli",
      "Una"
    ]
  },
  "Jammu and Kashmir": {
    "Anantnag": ["Anantnag", "Bijbehara", "Dooru", "Kokernag", "Pahalgam"],
    "Bandipora": ["Bandipora", "Gurez"],
    "Baramulla": ["Baramulla", "Sopore", "Gulmarg", "Uri", "Pattan"],
    "Budgam": ["Budgam", "Chadoora", "Beerwah"],
    "Ganderbal": ["Ganderbal", "Kangan"],
    "Jammu": ["Jammu", "Akhnoor", "Ranbir Singh Pora"],
    "Kargil": ["Kargil", "Zanskar"],
    "Kathua": ["Kathua", "Hiranagar", "Basohli", "Billawar"],
    "Kishtwar": ["Kishtwar", "Chhatru"],
    "Kulgam": ["Kulgam", "D.H. Pora"],
    "Kupwara": ["Kupwara", "Handwara", "Karnah"],
    "Leh": ["Leh"],
    "Pulwama": ["Pulwama", "Pampore", "Tral"],
    "Rajouri": ["Rajouri", "Nowshera", "Sunderbani", "Kalakote"],
    "Ramban": ["Ramban", "Banihal"],
    "Reasi": ["Reasi", "Mahore"],
    "Samba": ["Samba"],
    "Shopian": ["Shopian"],
    "Srinagar": ["Srinagar"],
    "Udhampur": ["Udhampur", "Chenani"]
  },
  "Jharkhand": {
    "Bokaro": [
      "Bermo",
      "Bokaro",
      "Chandankiyari",
      "Chas"
    ],
    "Chatra": [
      "Chatra",
      "Hunterganj",
      "Pratappur",
      "Simaria"
    ],
    "Deoghar": [
      "Deoghar",
      "Madhupur",
      "Palojori",
      "Sarath"
    ],
    "Dhanbad": [
      "Baghmara",
      "Dhanbad",
      "Govindpur",
      "Nirsa-cum-Chirkunda"
    ],
    "Dumka": [
      "Dumka",
      "Jama",
      "Ramgarh",
      "Saraiyahat"
    ],
    "Garhwa": [
      "Bhawnathpur",
      "Dandai",
      "Garhwa",
      "Ranka"
    ],
    "Giridih": [
      "Bagodar-Sariya",
      "Dhumri",
      "Giridih",
      "Pirtand"
    ],
    "Godda": [
      "Godda",
      "Mahagama",
      "Pathargama",
      "Poreyahat"
    ],
    "Gumla": [
      "Basia",
      "Chainpur",
      "Gumla",
      "Palkot"
    ],
    "Hazaribagh": [
      "Barkagaon",
      "Barkattha",
      "Barhi",
      "Hazaribagh",
      "Ichak"
    ],
    "Jamtara": [
      "Jamtara",
      "Kundhit",
      "Nala",
      "Narayanpur"
    ],
    "Khunti": [
      "Arki",
      "Khunti",
      "Murhu",
      "Torpa"
    ],
    "Koderma": [
      "Barhi",
      "Jainagar",
      "Koderma",
      "Markacho"
    ],
    "Latehar": [
      "Balumath",
      "Chandwa",
      "Latehar",
      "Mahuadand"
    ],
    "Lohardaga": [
      "Ghaghra",
      "Kisko",
      "Lohardaga",
      "Senha"
    ],
    "Pakur": [
      "Amrapara",
      "Hiranpur",
      "Litipara",
      "Maheshpur",
      "Pakur"
    ],
    "Palamu": [
      "Hussainabad",
      "Manatu",
      "Medininagar",
      "Panki"
    ],
    "Ramgarh": [
      "Gola",
      "Mandu",
      "Patratu",
      "Ramgarh"
    ],
    "Ranchi": [
      "Angara",
      "Bundu",
      "Burmu",
      "Chanho",
      "Kanke",
      "Lapung",
      "Mandara",
      "Ormanjhi",
      "Ranchi",
      "Ratu",
      "Silli",
      "Tamar"
    ],
    "Sahibganj": [
      "Barhait",
      "Borio",
      "Mandro",
      "Pathna",
      "Rajmahal",
      "Sahibganj",
      "Taljhari",
      "Udhwa"
    ],
    "Seraikela Kharsawan": [
      "Chandil",
      "Kharsawan",
      "Kuchai",
      "Nimdih",
      "Rajnagar",
      "Seraikela"
    ],
    "Simdega": [
      "Bano",
      "Jaldega",
      "Kolebira",
      "Kurdeg",
      "Simdega",
      "Thethaitanger"
    ],
    "West Singhbhum": [
      "Bandgaon",
      "Chakradharpur",
      "Chaibasa",
      "Goilkera",
      "Gua",
      "Jagannathpur",
      "Jhinkpani",
      "Manoharpur",
      "Manjhari",
      "Majhgaon",
      "Noamundi",
      "Sonua",
      "Tonto"
    ]
  },
  "Karnataka": {
    "Bagalkot": ["Badami", "Bagalkot", "Bilagi", "Hungund", "Ilkal", "Jamkhandi", "Mudhol", "Rabkavi Banhatti"],
    "Bangalore Rural": ["Devanahalli", "Doddaballapur", "Hosakote", "Nelamangala"],
    "Bangalore Urban": ["Bangalore South", "Bangalore North", "Bangalore East"],
    "Belgaum": ["Athani", "Bailhongal", "Belgaum", "Chikkodi", "Gokak", "Hukkeri", "Khanapur", "Mudalagi", "Ramdurg", "Raybag", "Saundatti"],
    "Bellary": ["Bellary", "Hadagali", "Hagaribommanahalli", "Hoovina Hadagali", "Kampli", "Kotturu", "Kudligi", "Sandur", "Siruguppa"],
    "Bidar": ["Aurad", "Basavakalyan", "Bhalki", "Bidar", "Humnabad"],
    "Chamarajanagar": ["Chamarajanagar", "Gundlupet", "Kollegal", "Yelandur"],
    "Chikballapur": ["Bagepalli", "Chikballapur", "Gauribidanur", "Gudibanda", "Sidlaghatta"],
    "Chikkamagaluru": ["Chikkamagaluru", "Kadur", "Mudigere", "Narasimharajapura", "Sringeri", "Tarikere"],
    "Chitradurga": ["Challakere", "Chitradurga", "Hiriyur", "Holalkere", "Hosadurga"],
    "Dakshina Kannada": ["Bantwal", "Belthangady", "Kadaba", "Mangalore", "Moodbidri", "Puttur", "Sullia"],
    "Davanagere": ["Channagiri", "Davanagere", "Harihar", "Honnali", "Jagaloor"],
    "Dharwad": ["Dharwad", "Hubli", "Kalghatgi", "Kundgol", "Navalgund"],
    "Gadag": ["Gadag", "Mundargi", "Nargund", "Ron", "Shirhatti"],
    "Gulbarga": ["Afzalpur", "Aland", "Chincholi", "Gulbarga", "Jevargi", "Sedam"],
    "Hassan": ["Alur", "Arsikere", "Belur", "Channarayapatna", "Hassan", "Holenarsipur", "Sakleshpur"],
    "Haveri": ["Byadgi", "Hangal", "Haveri", "Hirekerur", "Ranebennur", "Savanur", "Shiggaon"],
    "Kodagu": ["Madikeri", "Somwarpet", "Virajpet"],
    "Kolar": ["Bangarpet", "Kolar", "Malur", "Mulbagal", "Srinivaspur"],
    "Koppal": ["Gangawati", "Koppal", "Kushtagi", "Yelburga"],
    "Mandya": ["Krishnarajpet", "Malavalli", "Mandya", "Nagamangala", "Pandavapura", "Shrirangapattana"],
    "Mysore": ["Heggadadevanakote", "Hunsur", "Krishnarajanagara", "Mysore", "Nanjangud", "Periyapatna", "Tirumakudalu Narasipura"],
    "Raichur": ["Devadurga", "Lingsugur", "Manvi", "Raichur", "Sindhanur"],
    "Ramanagara": ["Channapatna", "Kanakapura", "Magadi", "Ramanagara"],
    "Shimoga": ["Bhadravati", "Hosanagara", "Sagar", "Shikaripur", "Shimoga", "Sorab", "Tirthahalli"],
    "Tumkur": ["Chiknayakanahalli", "Gubbi", "Koratagere", "Kunigal", "Madhugiri", "Pavagada", "Sira", "Tiptur", "Tumkur", "Turuvekere"],
    "Udupi": ["Karkala", "Kundapura", "Udupi"],
    "Uttara Kannada": ["Ankola", "Bhatkal", "Haliyal", "Honnavar", "Karwar", "Kumta", "Mundgod", "Siddapur", "Sirsi", "Yellapur"],
    "Vijayapura": ["Basavana Bagevadi", "Bijapur", "Chadchan", "Indi", "Mudhool"],
    "Yadgir": ["Shahapur", "Shorapur", "Yadgir"]
  },
  "Kerala": {
    "Alappuzha": ["Chengannur", "Cherthala", "Kuttanad", "Mavelikkara", "Ambalappuzha", "Karthikappally"],
    "Ernakulam": ["Aluva", "Kanayannur", "Kochi", "Kothamangalam", "Muvattupuzha", "Paravur", "Thodupuzha"],
    "Idukki": ["Devikulam", "Peerumade", "Thodupuzha", "Udumbanchola", "Idukki"],
    "Kannur": ["Taliparamba", "Kannur", "Thalassery", "Iritty", "Payyanur"],
    "Kasaragod": ["Kasaragod", "Hosdurg", "Vellarikundu", "Manjeshwaram"],
    "Kollam": ["Kollam", "Kunnathur", "Kottarakkara", "Pathanapuram", "Punalur", "Karunagappally"],
    "Kottayam": ["Kottayam", "Changanassery", "Vaikom", "Meenachil", "Kanjirappally"],
    "Kozhikode": ["Kozhikode", "Vadakara", "Koyilandy", "Thamarassery"],
    "Malappuram": ["Eranad", "Kondotty", "Nilambur", "Perinthalmanna", "Ponnani", "Tirur", "Tirurangadi"],
    "Palakkad": ["Palakkad", "Alathur", "Chittur", "Mannarkkad", "Ottapalam", "Pattambi"],
    "Pathanamthitta": ["Adoor", "Pathanamthitta", "Ranni", "Konni", "Mallappally", "Thiruvalla"],
    "Thiruvananthapuram": ["Thiruvananthapuram", "Nedumangad", "Neyyattinkara", "Kattakkada", "Varkala", "Chirayinkeezhu", "Attingal"],
    "Thrissur": ["Thrissur", "Chalakudy", "Kodungallur", "Mukundapuram", "Thalappilly", "Kunnamkulam", " Chavakkad"],
    "Wayanad": ["Mananthavady", "Sulthan Bathery", "Vythiri"]
  },
  "Madhya Pradesh": {
    "Agar Malwa": [
      "Agar",
      "Badod",
      "Nalkheda",
      "Susner"
    ],
    "Alirajpur": [
      "Alirajpur",
      "Bhabra",
      "Chandrapur",
      "Jobat"
    ],
    "Anuppur": [
      "Amarpur",
      "Anuppur",
      "Bajag",
      "Jaithari",
      "Kotma",
      "Pushprajgarh",
      "Shahpura"
    ],
    "Ashoknagar": [
      "Ashoknagar",
      "Chanderi",
      "Mungaoli",
      "Piprai"
    ],
    "Balaghat": [
      "Baihar",
      "Balaghat",
      "Katangi",
      "Kirnapur",
      "Lanji",
      "Waraseoni"
    ],
    "Barwani": [
      "Barwani",
      "Niwali",
      "Pansemal",
      "Rajpur",
      "Sendhwa",
      "Thikri"
    ],
    "Betul": [
      "Athner",
      "Bhainsdehi",
      "Betul",
      "Chicholi",
      "Multai",
      "Shahpur"
    ],
    "Bhind": [
      "Alampur",
      "Ambah",
      "Bhind",
      "Gohad",
      "Joura",
      "Lahar",
      "Mehgaon",
      "Mihona",
      "Porsa",
      "Raun"
    ],
    "Bhopal": [
      "Berasia",
      "Bhopal",
      "Huzur",
      "Kolar"
    ],
    "Burhanpur": [
      "Burhanpur",
      "Khaknar",
      "Nepanagar"
    ],
    "Chhatarpur": [
      "Bakswaha",
      "Bijawar",
      "Chandla",
      "Chhatarpur",
      "Gaurihar",
      "Khajuraho",
      "LavKushnagar",
      "Maharajpur",
      "Nowgaon",
      "Raj Nagar"
    ],
    "Chhindwara": [
      "Amarwara",
      "Bichhua",
      "Chhindwara",
      "Chourai",
      "Harrai",
      "Jamai",
      "Junnardeo",
      "Mohkhed",
      "Pandhurna",
      "Parasia",
      "Saunsar",
      "Tamia"
    ],
    "Damoh": [
      "Batiagarh",
      "Damoh",
      "Hatta",
      "Jabera",
      "Nohata",
      "Patharia",
      "Tendukheda"
    ],
    "Datia": [
      "Bhander",
      "Datia",
      "Indergarh",
      "Seondha"
    ],
    "Dewas": [
      "Bagli",
      "Dewas",
      "Kannod",
      "Khategaon",
      "Sonkatch"
    ],
    "Dhar": [
      "Badnawar",
      "Dhar",
      "Dharampuri",
      "Gandarwani",
      "Kukshi",
      "Manawar",
      "Nalchha",
      "Nisarpur",
      "Sardarpur"
    ],
    "Dindori": [
      "Amarpur",
      "Bajag",
      "Dindori",
      "Shahpura"
    ],
    "Guna": [
      "Aaron",
      "Bamori",
      "Guna",
      "Kumbhraj",
      "Raghogarh"
    ],
    "Gwalior": [
      "Bhitarwar",
      "Dabra",
      "Gird",
      "Gwalior"
    ],
    "Harda": [
      "Harda",
      "Khirkiya",
      "Rahatgaon",
      "Sirali",
      "Timarni"
    ],
    "Hoshangabad": [
      "Babai",
      "Bankhedi",
      "Hoshangabad",
      "Itarsi",
      "Pipariya",
      "Seoni-Malwa",
      "Sohagpur"
    ],
    "Indore": [
      "Depalpur",
      "Hatod",
      "Indore",
      "Mhow",
      "Sanwer"
    ],
    "Jabalpur": [
      "Adhartal",
      "Gorakhpur",
      "Jabalpur",
      "Kunda",
      "Kundam",
      "Majholi",
      "Patan",
      "Panagar",
      "Ranjhi",
      "Shahpura",
      "Sihora"
    ],
    "Jhabua": [
      "Jhabua",
      "Meghnagar",
      "Petlawad",
      "Ranapur",
      "Rambhabpur",
      "Thandla"
    ],
    "Katni": [
      "Badwara",
      "Bahoriband",
      "Barhi",
      "Dhimarkheda",
      "Katni",
      "Reethi",
      "Murwara",
      "Vijayraghavgarh"
    ],
    "Khandwa": [
      "Harsud",
      "Khalwa",
      "Khandwa",
      "Pandhana",
      "Punnasa"
    ],
    "Khargone": [
      "Barwaha",
      "Bhagwanpura",
      "Bhikangaon",
      "Gogawan",
      "Jhiranya",
      "Kasrawad",
      "Khargone",
      "Maheshwar",
      "Mandleshwar",
      "Sanawad",
      "Segaon"
    ],
    "Mandla": [
      "Bichhia",
      "Ghughri",
      "Mawai",
      "Mandla",
      "Mohgaon",
      "Nainpur",
      "NarayanGanj",
      "Niwas"
    ],
    "Mandsaur": [
      "Bhanpura",
      "Dalauda",
      "Garoth",
      "Malhargarh",
      "Mandsaur",
      "Sitamau",
      "Shamgarh",
      "Suwasra"
    ],
    "Morena": [
      "Ambah",
      "Dimani",
      "Joura",
      "Kailaras",
      "Morena",
      "Porsa",
      "Sabalgadh"
    ],
    "Narsinghpur": [
      "Gadarwara",
      "Gotegaon",
      "Kareli",
      "Narsinghpur",
      "Tendukheda"
    ],
    "Neemuch": [
      "Diken",
      "Jawad",
      "Manasa",
      "Neemuch",
      "Rampura",
      "Singoli"
    ],
    "Panna": [
      "Ajaigarh",
      "Devendranagar",
      "Gunour",
      "Panna",
      "Pawai",
      "Rajnagar",
      "Shahnagar"
    ],
    "Raisen": [
      "Begamganj",
      "Gairatganj",
      "Goharganj",
      "Raisen",
      "Sanchi",
      "Silwani",
      "Udaipura"
    ],
    "Rajgarh": [
      "Biaora",
      "Jirapur",
      "Khilchipur",
      "Narsinghgarh",
      "Pachore",
      "Rajgarh",
      "Sarangpur"
    ],
    "Ratlam": [
      "Alot",
      "Bajna",
      "Jaora",
      "Piploda",
      "Ratlam",
      "Sailana"
    ],
    "Rewa": [
      "Gurh",
      "Hanumana",
      "Huzur",
      "Mauganj",
      "Raipur Karchuliyan",
      "Rewa",
      "Semaria",
      "Sirmaur",
      "Teonthar"
    ],
    "Sagar": [
      "Bina",
      "Deori",
      "Garhakota",
      "Jaisinagar",
      "Khurai",
      "Malthone",
      "Rehli",
      "Sagar",
      "Shahgarh"
    ],
    "Satna": [
      "Amarpatan",
      "Maihar",
      "Majhgawan",
      "Nagod",
      "Rampur Baghelan",
      "Ramnagar",
      "Satna",
      "Uchehara"
    ],
    "Sehore": [
      "Ashta",
      "Budhani",
      "Ichhawar",
      "Nasrullaganj",
      "Rehti",
      "Sehore"
    ],
    "Seoni": [
      "Barghat",
      "Ghansor",
      "Keolari",
      "Lakhnadon",
      "Seoni"
    ],
    "Shahdol": [
      "Beohari",
      "Budhar",
      "Dhanpuri",
      "Gohparu",
      "Jaisinghnagar",
      "Shahdol",
      "Sohagpur",
      "Singhpur"
    ],
    "Shajapur": [
      "Gulana",
      "Kalapipal",
      "Moman Badod",
      "Shujalpur",
      "Shajapur",
      "Susner"
    ],
    "Sheopur": [
      "Baroda",
      "Karahal",
      "Sheopur",
      "Vijaypur"
    ],
    "Shivpuri": [
      "Badarwas",
      "Karera",
      "Khaniyadhana",
      "Kolaras",
      "Narwar",
      "Pichhore",
      "Shivpuri"
    ],
    "Sidhi": [
      "Churhat",
      "Devsar",
      "Kusmi",
      "Majhauli",
      "Rampur Naikin",
      "Sihawal",
      "Sidhi"
    ],
    "Singrauli": [
      "Chitrangi",
      "Deosar",
      "Mada",
      "Sarai",
      "Singrauli"
    ],
    "Tikamgarh": [
      "Baldeogarh",
      "Jatara",
      "Lidhora",
      "Mohangarh",
      "Niwari",
      "Orchha",
      "Prithvipur",
      "Tikamgarh"
    ],
    "Ujjain": [
      "Ghattiya",
      "Khacharod",
      "Mahidpur",
      "Nagda",
      "Raghogarh",
      "Tarana",
      "Ujjain"
    ],
    "Umria": [
      "Chandia",
      "Karkeli",
      "Manpur",
      "Pali",
      "Umria"
    ],
    "Vidisha": [
      "Basoda",
      "GyarasPur",
      "Kurwai",
      "Nateran",
      "Sironj",
      "Vidisha"
    ]
  },
  "Maharashtra": {
    "Ahilyanagar": [
      "Ahilyanagar",
      "Akole",
      "Jamkhed",
      "Karjat",
      "Kopargaon",
      "Newasa",
      "Parner",
      "Pathardi",
      "Rahata",
      "Rahuri",
      "Sangamner",
      "Shevgaon",
      "Shrigonda"
    ],
    "Akola": [
      "Akola",
      "Akot",
      "Balapur",
      "Barshitakli",
      "Murtijapur",
      "Patur",
      "Telhara"
    ],
    "Amravati": [
      "Achalpur",
      "Amravati",
      "Anjangaon-Surji",
      "Bhatkuli",
      "Chandur Bazar",
      "Chandur Railway",
      "Chikhaldara",
      "Daryapur",
      "Dhamangaon Railway",
      "Dharni",
      "Morshi",
      "Nandgaon Khandeshwar",
      "Tiosa",
      "Warud"
    ],
    "Beed": [
      "Ashti",
      "Beed",
      "Dharur",
      "Georai",
      "Kaij",
      "Majalgaon",
      "Parli Vaijnath",
      "Patoda",
      "Shirur Kasar",
      "Wadwani"
    ],
    "Bhandara": [
      "Bhandara",
      "Lakhandur",
      "Mohadi",
      "Pauni",
      "Sakoli",
      "Tumsar"
    ],
    "Buldhana": [
      "Buldhana",
      "Chikhli",
      "Deulgaon Raja",
      "Jalgaon Jamod",
      "Khamgaon",
      "Lonar",
      "Malkapur",
      "Mehkar",
      "Motala",
      "Nandura",
      "Sangrampur",
      "Shegaon",
      "Sindkhed Raja"
    ],
    "Chandrapur": [
      "Ballarpur",
      "Bhadravati",
      "Brahmapuri",
      "Chandrapur",
      "Chimur",
      "Jivti",
      "Korapana",
      "Mul",
      "Nagbhid",
      "Pombhurna",
      "Rajura",
      "Savali",
      "Sindewahi",
      "Warora"
    ],
    "Chh. Sambhajinagar": [
      "Chh. Sambhajinagar",
      "Gangapur",
      "Kannad",
      "Khultabad",
      "Paithan",
      "Phulambri",
      "Sillod",
      "Soegaon",
      "Vaijapur"
    ],
    "Dharashiv": [
      "Bhoom",
      "Dharashiv",
      "Kallam",
      "Lohara",
      "Paranda",
      "Tuljapur",
      "Umarga",
      "Washi"
    ],
    "Dhule": [
      "Dhule",
      "Sakri",
      "Shindkheda",
      "Shirpur"
    ],
    "Gadchiroli": [
      "Aheri",
      "Armori",
      "Bhamragad",
      "Chamorshi",
      "Desaiganj",
      "Dhanora",
      "Etapalli",
      "Gadchiroli",
      "Korchi",
      "Kurkheda",
      "Mulchera",
      "Sironcha"
    ],
    "Gondia": [
      "Amgaon",
      "Arjuni Morgaon",
      "Devri",
      "Gondia",
      "Goregaon",
      "Sadak Arjuni",
      "Salekasa",
      "Tirora"
    ],
    "Hingoli": [
      "Aundha Nagnath",
      "Basmath",
      "Hingoli",
      "Kalamnuri",
      "Sengaon"
    ],
    "Jalgaon": [
      "Amalner",
      "Bhadgaon",
      "Bhusawal",
      "Bodwad",
      "Chalisgaon",
      "Chopda",
      "Dharangaon",
      "Erandol",
      "Jalgaon",
      "Jamner",
      "Muktainagar",
      "Pachora",
      "Parola",
      "Raver",
      "Yawal"
    ],
    "Jalna": [
      "Ambad",
      "Badnapur",
      "Bhokardan",
      "Ghansawangi",
      "Jafrabad",
      "Jalna",
      "Mantha",
      "Partur"
    ],
    "Kolhapur": [
      "Ajra",
      "Bhudargad",
      "Chandgad",
      "Gaganbawada",
      "Gadhinglaj",
      "Hatkanangle",
      "Karveer",
      "Kolhapur",
      "Panhala",
      "Radhanagari",
      "Shahuwadi",
      "Shirol"
    ],
    "Latur": [
      "Ahmedpur",
      "Ausa",
      "Chakur",
      "Devani",
      "Jalkot",
      "Latur",
      "Nilanga",
      "Renapur",
      "Shirur Anantpal",
      "Udgir"
    ],
    "Mumbai City": [
      "Mumbai City"
    ],
    "Mumbai Suburban": [
      "Andheri",
      "Borivali",
      "Kurla",
      "Mumbai Suburban"
    ],
    "Nanded": [
      "Bhokar",
      "Biloli",
      "Degloor",
      "Dharmabad",
      "Hadgaon",
      "Kandhar",
      "Kinwat",
      "Loha",
      "Mukhed",
      "Nanded",
      "Naygaon",
      "Umri"
    ],
    "Nandurbar": [
      "Akkalkuwa",
      "Akrani",
      "Dhadgaon",
      "Nandurbar",
      "Navapur",
      "Shahada",
      "Taloda"
    ],
    "Nagpur": [
      "Hingna",
      "Kalameshwar",
      "Kamptee",
      "Katol",
      "Kuhi",
      "Mouda",
      "Nagpur City",
      "Narkhed",
      "Ramtek",
      "Savner",
      "Umred"
    ],
    "Nashik": [
      "Baglan",
      "Chandwad",
      "Deola",
      "Dindori",
      "Igatpuri",
      "Kalwan",
      "Malegaon",
      "Nandgaon",
      "Nashik",
      "Niphad",
      "Peth",
      "Satana",
      "Sinnar",
      "Surgana",
      "Trimbakeshwar",
      "Yeola"
    ],
    "Palghar": [
      "Dahanu",
      "Jawhar",
      "Mokhada",
      "Palghar",
      "Talassari",
      "Vasai",
      "Vikramgad",
      "Wada"
    ],
    "Parbhani": [
      "Gangakhed",
      "Jintur",
      "Manwat",
      "Palam",
      "Parbhani",
      "Pathri",
      "Purna",
      "Selu"
    ],
    "Pune": [
      "Ambegaon",
      "Baramati",
      "Bhor",
      "Daund",
      "Haveli",
      "Indapur",
      "Junnar",
      "Khed",
      "Maval",
      "Mulshi",
      "Pune City",
      "Purandar",
      "Shirur",
      "Velhe"
    ],
    "Raigad": [
      "Alibag",
      "Karjat",
      "Khalapur",
      "Mahad",
      "Mangaon",
      "Mhasla",
      "Murud",
      "Panvel",
      "Pen",
      "Poladpur",
      "Roha",
      "Shrivardhan",
      "Tala"
    ],
    "Ratnagiri": [
      "Chiplun",
      "Dapoli",
      "Devrukh",
      "Guhagar",
      "Khed",
      "Lanja",
      "Mandangad",
      "Rajapur",
      "Ratnagiri",
      "Sangameshwar"
    ],
    "Sangli": [
      "Atpadi",
      "Jat",
      "Kadegaon",
      "Kavathe Mahankal",
      "Khanapur Vita",
      "Miraj",
      "Palus",
      "Sangli",
      "Shirala",
      "Tasgaon",
      "Walwa"
    ],
    "Satara": [
      "Dahiwadi",
      "Karad",
      "Khatav",
      "Koregaon",
      "Mahabaleshwar",
      "Man",
      "Patan",
      "Phaltan",
      "Satara",
      "Wai"
    ],
    "Sindhudurg": [
      "Devgad",
      "Dodamarg",
      "Kankavli",
      "Kudal",
      "Malvan",
      "Sawantwadi",
      "Vaibhavwadi",
      "Vengurla"
    ],
    "Solapur": [
      "Akkalkot",
      "Barshi",
      "Karmala",
      "Madha",
      "Malshiras",
      "Mangalvedhe",
      "Mohol",
      "North Solapur",
      "Pandharpur",
      "Sangola",
      "Solapur City",
      "South Solapur"
    ],
    "Thane": [
      "Ambernath",
      "Bhiwandi",
      "Kalyan",
      "Murbad",
      "Shahapur",
      "Thane",
      "Ulhasnagar",
      "Vikramgad",
      "Wada"
    ],
    "Wardha": [
      "Arvi",
      "Ashti",
      "Deoli",
      "Hinganghat",
      "Karanja",
      "Samudrapur",
      "Seloo",
      "Wardha"
    ],
    "Washim": [
      "Karanja",
      "Malegaon",
      "Manora",
      "Mangrulpir",
      "Risod",
      "Washim"
    ],
    "Yavatmal": [
      "Arni",
      "Babhulgaon",
      "Darwha",
      "Digras",
      "Ghatanji",
      "Jhari Jamni",
      "Kelapur",
      "Mahagaon",
      "Ner",
      "Pusad",
      "Ralegaon",
      "Umarkhed",
      "Wani",
      "Yavatmal"
    ]
  },
  "Manipur": {
    "Bishnupur": ["Bishnupur", "Moirang", "Kumbi"],
    "Chandel": ["Chandel", "Machhi", " Chakpikarong"],
    "Churachandpur": ["Churachandpur", "Tipaimukh", "Thanlon"],
    "Imphal East": ["Imphal", "Keirao Bitra"],
    "Imphal West": ["Lamsang", "Patsoi"],
    "Jiribam": ["Jiribam"],
    "Kakching": ["Kakching", "Wabagai"],
    "Kamjong": ["Kamjong", " Phungyar"],
    "Kangpokpi": ["Kangpokpi", "Saitu Gamphazol"],
    "Noney": ["Noney", "Longmai"],
    "Pherzawl": ["Pherzawl"],
    "Senapati": ["Senapati", "Mao-Maram", "Paomata"],
    "Tamenglong": ["Tamenglong", "Tousem"],
    "Tengnoupal": ["Tengnoupal", "Moreh"],
    "Thoubal": ["Thoubal", "Lilong"],
    "Ukhrul": ["Ukhrul", "Kamjong", "Lungchong Maiphei"]
  },
  "Meghalaya": {
    "East Garo Hills": ["Williamnagar", "Samanda"],
    "East Jaintia Hills": ["Khliehriat", "Saipung"],
    "East Khasi Hills": ["Shillong", "Mylliem"],
    "North Garo Hills": ["Resubelpara", "Kharkutta"],
    "Ri-Bhoi": ["Nongpoh", " Jirang"],
    "South Garo Hills": ["Baghmara", " Chokpot"],
    "South West Garo Hills": ["Ampati", "Zikzak"],
    "South West Khasi Hills": ["Mawkyrwat"],
    "West Garo Hills": ["Tura", " Dadenggre"],
    "West Jaintia Hills": ["Jowai", "Thadlaskein"],
    "West Khasi Hills": ["Nongstoin", "Mawshynrut"]
  },
  "Mizoram": {
    "Aizawl": ["Aizawl", "Tlangnuam"],
    "Champhai": ["Champhai", "Khawbung"],
    "Hnahthial": ["Hnahthial"],
    "Khawzawl": ["Khawzawl"],
    "Kolasib": ["Kolasib", "Bilkhawthlir"],
    "Lawngtlai": ["Lawngtlai", "Sangau"],
    "Lunglei": ["Lunglei", "Tlabung"],
    "Mamit": ["Mamit", " Zawlnuam"],
    "Saiha": ["Saiha", "Tuipang"],
    "Serchhip": ["Serchhip", " Thenzawl"],
    "Siaha": ["Siaha"]
  },
  "Nagaland": {
    "Dimapur": ["Dimapur", " Niuland"],
    "Kiphire": ["Kiphire", "Pungro"],
    "Kohima": ["Kohima", " Jakhama"],
    "Longleng": ["Longleng", " Tamlu"],
    "Mokokchung": ["Mokokchung", " Mangkolemba"],
    "Mon": ["Mon", " Aboi"],
    "Peren": ["Peren", " Jalukie"],
    "Phek": ["Phek", " Meluri"],
    "Tuensang": ["Tuensang", " Noksen"],
    "Wokha": ["Wokha", " Baghty"],
    "Zunheboto": ["Zunheboto", " Akuluto"]
  },
  "Odisha": {
    "Angul": [
      "Angul",
      "Chhendipada",
      "Kishore Nagar",
      "Pallahara",
      "Talcher"
    ],
    "Balangir": [
      "Agalpur",
      "Balangir",
      "Belpada",
      "Gudvela",
      "Kantabanji",
      "Khaprakhol",
      "Loisingha",
      "MuriBahal",
      "Patnagarh",
      "Saintala",
      "Titlagarh",
      "Turekela"
    ],
    "Baleswar": [
      "Bahanga",
      "Baleswar",
      "Baliapal",
      "Basta",
      "Bhograi",
      "Jaleswar",
      "Khaunta",
      "Nilagiri",
      "Oupada",
      "Remuna",
      "Simulia",
      "Soro"
    ],
    "Bargarh": [
      "Attabira",
      "Bargarh",
      "Barpali",
      "Bijepur",
      "Gaisilet",
      "Jharbandh",
      "Padampur",
      "Paikmal",
      "Sohela"
    ],
    "Bhadrak": [
      "Bant",
      "Basudevpur",
      "Bhadrak",
      "Chandbali",
      "Dhamnagar",
      "Tihidi"
    ],
    "Boudh": [
      "Athmallik",
      "Boudh",
      "Harbhanga",
      "Kantamal",
      "Manamunda",
      "Puruna Cuttack"
    ],
    "Cuttack": [
      "Athagad",
      "Banki",
      "Baramba",
      "Cuttack",
      "Kantapada",
      "Mahanga",
      "Narsinghpur",
      "Niali",
      "Salepur",
      "Tangi-Choudwar"
    ],
    "Deogarh": [
      "Barkote",
      "Deogarh",
      "Reamal",
      "Tileibani"
    ],
    "Dhenkanal": [
      "Dhenkanal",
      "Gondia",
      "Hindol",
      "Kamakhyanagar",
      "Kankadahad",
      "Odapada",
      "Parjang"
    ],
    "Gajapati": [
      "Gumma",
      "Kashinagar",
      "Mohana",
      "Nuagada",
      "Paralakhemundi",
      "R.Udayagiri",
      "Rayagada"
    ],
    "Ganjam": [
      "Aska",
      "Bellaguntha",
      "Bhanjanagar",
      "Brahmapur",
      "Buguda",
      "Chatrapur",
      "Chikiti",
      "Dharakote",
      "Digapahandi",
      "Ganjam",
      "Hinjilicut",
      "Jagannathprasad",
      "Kabisuryanagar",
      "Khalikote",
      "Kodala",
      "Kukudakhandi",
      "Polsara",
      "Purushottampur",
      "Sanakhemundi",
      "Sheragada",
      "Sorada"
    ],
    "Jagatsinghpur": [
      "Balikuda",
      "Biridi",
      "Jagatsinghpur",
      "Kujang",
      "Paradeep",
      "Raghunathpur",
      "Tirtol"
    ],
    "Jajpur": [
      "Badachana",
      "Bari",
      "Binjharpur",
      "Chandikhole",
      "Danagadi",
      "Dharmasala",
      "Jajpur",
      "Korai",
      "Panikoili",
      "Rasulpur",
      "Sukinda"
    ],
    "Jharsuguda": [
      "Brajarajnagar",
      "Jharsuguda",
      "Kirmira",
      "Kolabira",
      "Laikera",
      "Lakhanpur"
    ],
    "Kalahandi": [
      "Bhawanipatna",
      "Dharmagarh",
      "Golamunda",
      "Jaipatna",
      "Junagarh",
      "Kalahandi",
      "Karlamunda",
      "Kesinga",
      "Koksara",
      "Lanjigarh",
      "Madanpur Rampur",
      "Narla",
      "Th.Rampur"
    ],
    "Kandhamal": [
      "Baliguda",
      "Chakapad",
      "Daringbadi",
      "Firingsia",
      "G.Udayagiri",
      "K.Nuagaon",
      "Kotagarh",
      "Phiringia",
      "Phulbani",
      "Raikia",
      "Tikabali",
      "Tumudibandha"
    ],
    "Kendrapara": [
      "Aul",
      "Derabish",
      "Garadapur",
      "Kendrapara",
      "Mahakalapada",
      "Marshaghai",
      "Pattamundai",
      "Rajnagar"
    ],
    "Kendujhar": [
      "Anandapur",
      "Banspal",
      "Barbil",
      "Champua",
      "Ghatagaon",
      "Harichandanpur",
      "Jhumpura",
      "Kendujhar",
      "Patna",
      "Saharpada",
      "Telkoi"
    ],
    "Khordha": [
      "Balipatna",
      "Balugaon",
      "Banapur",
      "Begunia",
      "Bhubaneswar",
      "Bolagarh",
      "Chandapur",
      "Chilika",
      "Jatani",
      "Khordha",
      "Tangi"
    ],
    "Koraput": [
      "Bandhugaon",
      "Borigumma",
      "Dasamantapur",
      "Jeypore",
      "Koraput",
      "Kotpad",
      "Kundra",
      "Laxmipur",
      "Nandapur",
      "Narayanpatna",
      "Pottangi",
      "Semiliguda"
    ],
    "Malkangiri": [
      "Chitrakonda",
      "Kalimela",
      "Khairaput",
      "Korkonda",
      "Kudumulgumma",
      "Malkangiri",
      "Mathili",
      "Podia"
    ],
    "Mayurbhanj": [
      "Bahalda",
      "Baripada",
      "Barsahi",
      "Betnoti",
      "Bisoi",
      "Gopabandhunagar",
      "Jashipur",
      "Karanjia",
      "Khunta",
      "Kusumi",
      "Kuliana",
      "Muruda",
      "Rairangpur",
      "Raruan",
      "Samakhunta",
      "Saraskana",
      "Shamakhunta",
      "Sukruli",
      "Thakurmunda",
      "Tiring",
      "Udala"
    ],
    "Nabarangpur": [
      "Chandahandi",
      "Jharigam",
      "Kosagumuda",
      "Nabarangpur",
      "Nandahandi",
      "Papadahandi",
      "Raighar",
      "Tentulikhunti",
      "Umerkote"
    ],
    "Nayagarh": [
      "Bhapur",
      "Daspalla",
      "Gania",
      "Khandapada",
      "Nayagarh",
      "Nuagaon",
      "Odagaon",
      "Ranpur"
    ],
    "Nuapada": [
      "Boden",
      "Khariar",
      "Komna",
      "Nuapada",
      "Sinapali"
    ],
    "Puri": [
      "Astaranga",
      "Brahmagiri",
      "Delanga",
      "Gop",
      "Kakatpur",
      "Konark",
      "Nimapara",
      "Pipili",
      "Puri",
      "Sadar"
    ],
    "Rayagada": [
      "Bissamcuttack",
      "Chandrapur",
      "Colnarah",
      "Gudari",
      "Gunupur",
      "Kalyansinghpur",
      "Kashipur",
      "Muniguda",
      "Padmapur",
      "Rayagada"
    ],
    "Sambalpur": [
      "Bamra",
      "Dhanakauda",
      "Jamankira",
      "Jharsuguda",
      "Kuchinda",
      "Maneswar",
      "Naktideul",
      "Rairakhol",
      "Redhakhol",
      "Sambalpur"
    ],
    "Subarnapur": [
      "Binka",
      "Dunguripali",
      "Sonepur",
      "Tarbha",
      "Ullunda"
    ],
    "Sundargarh": [
      "Balisankara",
      "Banei",
      "Bonai",
      "Gurundia",
      "Hemgir",
      "Koida",
      "Kutra",
      "Lahunipada",
      "Lathikata",
      "Lephripara",
      "Rajgangpur",
      "Rourkela",
      "Subdega",
      "Sundargarh",
      "Tangarpali"
    ]
  },
  "Punjab": {
    "Amritsar": [
      "Ajnala",
      "Amritsar I",
      "Amritsar II",
      "Baba Bakala",
      "Attari"
    ],
    "Barnala": [
      "Barnala",
      "Bhadaur",
      "Dhanaula",
      "Mehal Kalan",
      "Tapa"
    ],
    "Bathinda": [
      "Bathinda",
      "Maur",
      "Rampura Phul",
      "Talwandi Sabo"
    ],
    "Faridkot": [
      "Faridkot",
      "Jaitu",
      "Kotkapura",
      "Sadik"
    ],
    "Fatehgarh Sahib": [
      "Amloh",
      "Bassi Pathana",
      "Fatehgarh Sahib",
      "Khamanon"
    ],
    "Fazilka": [
      "Abohar",
      "Arniwala Sheikh Subhan",
      "Fazilka",
      "Jalalabad",
      "Khui Khera"
    ],
    "Ferozepur": [
      "Ferozepur",
      "Guru Har Sahai",
      "Mamdot",
      "Zira"
    ],
    "Gurdaspur": [
      "Batala",
      "Dera Baba Nanak",
      "Dhariwal",
      "Gurdaspur"
    ],
    "Hoshiarpur": [
      "Dasua",
      "Garhshankar",
      "Hoshiarpur",
      "Mukerian"
    ],
    "Jalandhar": [
      "Jalandhar I",
      "Jalandhar II",
      "Nakodar",
      "Phillaur",
      "Shahkot"
    ],
    "Kapurthala": [
      "Bhulath",
      "Kapurthala",
      "Phagwara",
      "Sultanpur Lodhi"
    ],
    "Ludhiana": [
      "Jagraon",
      "Khanna",
      "Ludhiana East",
      "Ludhiana West",
      "Payal",
      "Raikot",
      "Samrala"
    ],
    "Mansa": [
      "Bhikhi",
      "Budhlada",
      "Mansa",
      "Sardulgarh"
    ],
    "Moga": [
      "Bagha Purana",
      "Dharamkot",
      "Moga",
      "Nihal Singh Wala"
    ],
    "Pathankot": [
      "Dhar Kalan",
      "Dinanagar",
      "Pathankot",
      "Sujanpur"
    ],
    "Patiala": [
      "Nabha",
      "Patiala",
      "Rajpura",
      "Samana"
    ],
    "Rupnagar": [
      "Anandpur Sahib",
      "Chamkaur Sahib",
      "Morinda",
      "Nangal",
      "Rupnagar"
    ],
    "Sahibzada Ajit Singh Nagar": [
      "Dera Bassi",
      "Kharar",
      "Mohali"
    ],
    "Sangrur": [
      "Ahmedgarh",
      "Bhawanigarh",
      "Dirba",
      "Dhuri",
      "Lehragaga",
      "Malerkotla",
      "Moonak",
      "Sangrur",
      "Sunam"
    ],
    "Shahid Bhagat Singh Nagar": [
      "Balachaur",
      "Banga",
      "Nawanshahr"
    ],
    "Sri Muktsar Sahib": [
      "Bariwala",
      "Gidderbaha",
      "Malout",
      "Muktsar"
    ],
    "Tarn Taran": [
      "Bhikhiwind",
      "Khadoor Sahib",
      "Patti",
      "Tarn Taran"
    ]
  },
  "Puducherry": {
    "Puducherry": ["Puducherry"],
    "Karaikal": ["Karaikal"],
    "Mahe": ["Mahe"],
    "Yanam": ["Yanam"]
  },
  "Rajasthan": {
    "Ajmer": [
      "Ajmer",
      "Arain",
      "Beawar",
      "Bhinai",
      "Kekri",
      "Kishangarh",
      "Nasirabad",
      "Peesangan",
      "Pushkar",
      "Roopangarh",
      "Sarwar",
      "Sawar",
      "Tantoti",
      "Todgarh"
    ],
    "Alwar": [
      "Alwar",
      "Behror",
      "Govindgarh",
      "Kathumar",
      "Kishangarhbas",
      "Lachhmangarh",
      "Mundawar",
      "Rajgarh",
      "Ramgarh",
      "Thanagazi",
      "Tijara"
    ],
    "Banswara": [
      "Anandpuri",
      "Bagidora",
      "Banswara",
      "Chhoti Sarwan",
      "Garhi",
      "Ghatol",
      "Kushalgarh",
      "Sajjangarh"
    ],
    "Baran": [
      "Antah",
      "Atru",
      "Baran",
      "Chhabra",
      "Chhipabarod",
      "Kawai",
      "Kishanganj",
      "Mangrol",
      "Shahabad"
    ],
    "Barmer": [
      "Barmer",
      "Baytoo",
      "Baitu Chimnji",
      "Balotra",
      "Dhorimanna",
      "Gida",
      "Gudamalani",
      "Kalyanpur",
      "Pachpadra",
      "Ramsar",
      "Samdari",
      "Sedwa",
      "Sheo",
      "Shiv",
      "Siwana"
    ],
    "Bharatpur": [
      "Bari",
      "Baseri",
      "Bayana",
      "Bharatpur",
      "Deeg",
      "Kaman",
      "Kumher",
      "Nadbai",
      "Nagar",
      "Pahari",
      "Roopwas"
    ],
    "Bhilwara": [
      "Asind",
      "Badnor",
      "Beejoliya",
      "Bhilwara",
      "Bijoliya",
      "Banera",
      "Hurda",
      "Jahazpur",
      "Kareda",
      "Kotri",
      "Mandal",
      "Mandalgarh",
      "Raipur",
      "Sahara",
      "Shahpura",
      "Suwana"
    ],
    "Bikaner": [
      "Bikaner",
      "Chhatargarh",
      "Dungargarh",
      "Kolayat",
      "Khajuwala",
      "Lunkaransar",
      "Nokha",
      "Sridungargarh"
    ],
    "Bundi": [
      "Bundi",
      "Dablana",
      "Dei",
      "Hindoli",
      "Indragarh",
      "Kaprain",
      "Keshoraipatan",
      "Nainwa",
      "Patan"
    ],
    "Chittorgarh": [
      "Akotla",
      "Anupgarh",
      "Arnod",
      "Begun",
      "Bhadesar",
      "Bhensrodgarh",
      "Chhoti Sadri",
      "Chittorgarh",
      "Dungla",
      "Gangarar",
      "Kapasan",
      "Nimbahera",
      "Badi Sadri",
      "Parsoli",
      "Rawatbhata"
    ],
    "Churu": [
      "Bhadra",
      "Bidasar",
      "Chhapar",
      "Churu",
      "Dungargarh",
      "Rajgarh",
      "Ratangarh",
      "Sadulpur",
      "Sardarshahar",
      "Sujangarh",
      "Taranagar"
    ],
    "Dausa": [
      "Baswa",
      "Dausa",
      "Lalsot",
      "Mahwa",
      "Ramgarh Pachwara",
      "Sainthal",
      "Sikrai"
    ],
    "Dholpur": [
      "Badi",
      "Baseri",
      "Dholpur",
      "Rajakhera",
      "Sepau"
    ],
    "Dungarpur": [
      "Aspur",
      "Dungarpur",
      "Jhonthri",
      "Sagwara",
      "Simalwara"
    ],
    "Hanumangarh": [
      "Bhadra",
      "Hanumangarh",
      "Nohar",
      "Pilibanga",
      "Rawatsar",
      "Sangaria",
      "Tibbi"
    ],
    "Jaipur": [
      "Amer",
      "Bassi",
      "Chaksu",
      "Dudu",
      "Jaipur",
      "Jamwa Ramgarh",
      "Jobner",
      "Kotputli",
      "Sambhar",
      "Sanganer",
      "Shahpura",
      "Viratnagar"
    ],
    "Jaisalmer": [
      "Fatehgarh",
      "Jaisalmer",
      "Mohangarh",
      "Pokaran",
      "Ramdevra"
    ],
    "Jalore": [
      "Ahore",
      "Bhinmal",
      "Chitalwana",
      "Jalore",
      "Jaswantpura",
      "Raniwara",
      "Sanchore",
      "Sayla"
    ],
    "Jhalawar": [
      "Aklera",
      "Bakani",
      "Dag",
      "Jhalawar",
      "Khanpur",
      "Manohar Thana",
      "Pachpahar",
      "Pirawa"
    ],
    "Jhunjhunu": [
      "Buhana",
      "Chirawa",
      "Jhunjhunu",
      "Khetri",
      "Nawalgarh",
      "Surajgarh",
      "Udaipurwati"
    ],
    "Jodhpur": [
      "Balesar",
      "Bawadi",
      "Bilara",
      "Bhoplgarh",
      "Phalodi",
      "Jodhpur",
      "Luni",
      "Osian",
      "Shergarh"
    ],
    "Karauli": [
      "Hindaun",
      "Karauli",
      "Mandrayal",
      "Nadauti",
      "Sapotra",
      "Todabhim"
    ],
    "Kota": [
      "Itarwa",
      "Kaithoon",
      "Khanpur",
      "Kota",
      "Ladpura",
      "Ramganj Mandi",
      "Sangod"
    ],
    "Nagaur": [
      "Degana",
      "Didwana",
      "Jayal",
      "Khinvsar",
      "Ladnun",
      "Merta",
      "Nagaur",
      "Parbatsar"
    ],
    "Pali": [
      "Bali",
      "Desuri",
      "Jaitaran",
      "Kharchi",
      "Marwar Junction",
      "Nadol",
      "Pali",
      "Rani",
      "Raipur",
      "Rohat",
      "Sojat",
      "Sumerpur"
    ],
    "Pratapgarh": [
      "Arnod",
      "Chhoti Sadri",
      "Dhariawad",
      "Pipalkhunt",
      "Pratapgarh"
    ],
    "Rajsamand": [
      "Amet",
      "Bhim",
      "Deogarh",
      "Garbor",
      "Khamnor",
      "Kumbhalgarh",
      "Kunwariya",
      "Relmagra",
      "Rajsamand"
    ],
    "Sawai Madhopur": [
      "Bamanwas",
      "Baunli",
      "Gangapur",
      "Gangapur City",
      "Khandar",
      "Malarna Dungar",
      "Sawai Madhopur"
    ],
    "Sikar": [
      "Dataramgarh",
      "Danta Ramgarh",
      "Dhod",
      "Fatehpur",
      "Khandela",
      "Laxmangarh",
      "Neemkathana",
      "Shrimadhopur",
      "Sikar"
    ],
    "Sirohi": [
      "Abu Road",
      "Pindwara",
      "Reodar",
      "Sirohi",
      "Sheoganj"
    ],
    "Sri Ganganagar": [
      "Anupgarh",
      "Ganganagar",
      "Karanpur",
      "Padampur",
      "Raisinghnagar",
      "Sadulshahar",
      "Sribijaynagar",
      "Vijaynagar"
    ],
    "Tonk": [
      "Deoli",
      "Malpura",
      "Niwai",
      "Piplu",
      "Todaraisingh",
      "Tonk",
      "Uniara"
    ],
    "Udaipur": [
      "Girwa",
      "Gogunda",
      "Jhadol",
      "Kherwara",
      "Kotda",
      "Lasadiya",
      "Mavli",
      "Salumber",
      "Sarada",
      "Vallabhnagar",
      "Udaipur"
    ]
  },
  "Sikkim": {
    "East Sikkim": ["Gangtok", "Pakyong"],
    "North Sikkim": ["Mangan"],
    "South Sikkim": ["Namchi"],
    "West Sikkim": ["Gyalshing"]
  },
  "Tamil Nadu": {
    "Ariyalur": [
      "Andimadam",
      "Ariyalur",
      "Sendurai",
      "Udayarpalayam"
    ],
    "Chengalpattu": [
      "Alanthur",
      "Chengalpattu",
      "Cheyyur",
      "Madurantakam",
      "Pallavaram",
      "Tambaram",
      "Thirukazhukundram",
      "Tiruporur"
    ],
    "Chennai": [
      "Egmore",
      "Fort Tondiarpet",
      "Mylapore",
      "Perambur"
    ],
    "Coimbatore": [
      "Annur",
      "Coimbatore North",
      "Coimbatore South",
      "Mettupalayam",
      "Pollachi",
      "Sulur",
      "Valparai"
    ],
    "Cuddalore": [
      "Bhuvanagiri",
      "Chidambaram",
      "Cuddalore",
      "Kurinjipadi",
      "Panruti",
      "Tittakudi",
      "Vriddhachalam"
    ],
    "Dharmapuri": [
      "Dharmapuri",
      "Harur",
      "Palacode",
      "Pennagaram"
    ],
    "Dindigul": [
      "Athoor",
      "Dindigul",
      "Kodaikanal",
      "Natham",
      "Nilakottai",
      "Oddanchatram",
      "Palani",
      "Vedasandur"
    ],
    "Erode": [
      "Anthiyur",
      "Bhavani",
      "Erode",
      "Gobichettipalayam",
      "Kodumudi",
      "Modakurichi",
      "Perundurai",
      "Sathyamangalam",
      "T.N.Palayam",
      "Thalavadi"
    ],
    "Kallakurichi": [
      "Chinnasalem",
      "Kallakurichi",
      "Kalvarayanmalai",
      "Rishivandiyam",
      "Sankarapuram",
      "Thirukoilur",
      "Ulundurpet"
    ],
    "Kanchipuram": [
      "Kanchipuram",
      "Sriperumbudur",
      "Uthiramerur",
      "Walajabad"
    ],
    "Kanyakumari": [
      "Agastheeswaram",
      "Kalkulam",
      "Munchirai",
      "Thiruvattar",
      "Thovalai",
      "Vilavancode"
    ],
    "Karur": [
      "Kadavur",
      "Karur",
      "Krishnarayapuram",
      "Kulithalai",
      "Manmangalam",
      "Thanthoni"
    ],
    "Krishnagiri": [
      "Bargur",
      "Denkanikottai",
      "Hosur",
      "Krishnagiri",
      "Pochampalli",
      "Uthangarai"
    ],
    "Madurai": [
      "Chellampatti",
      "Madurai North",
      "Madurai South",
      "Melur",
      "Peraiyur",
      "Sholavandan",
      "Thirumangalam",
      "Thirumohur",
      "Thirupparankundram",
      "Usilampatti",
      "Vadipatti"
    ],
    "Mayiladuthurai": [
      "Kuthalam",
      "Mayiladuthurai",
      "Sirkazhi",
      "Tharangambadi"
    ],
    "Nagapattinam": [
      "Kilvelur",
      "Nagapattinam",
      "Thirukkuvalai",
      "Vedaranyam"
    ],
    "Namakkal": [
      "Erumapatti",
      "Kollimalai",
      "Mohanur",
      "Namakkal",
      "Paramathi-Velur",
      "Puduchatram",
      "Rasipuram",
      "Senthamangalam"
    ],
    "Nilgiris": [
      "Coonoor",
      "Gudalur",
      "Kotagiri",
      "Kundah",
      "Pandhalur",
      "Udhagamandalam"
    ],
    "Perambalur": [
      "Kunnam",
      "Perambalur",
      "Veppanthattai"
    ],
    "Pudukkottai": [
      "Alangudi",
      "Aranthangi",
      "Avudaiyarkoil",
      "Gandharvakottai",
      "Karambakkudi",
      "Kulathur",
      "Manamelkudi",
      "Ponnamaravathi",
      "Pudukkottai",
      "Thirumayam",
      "Viralimalai"
    ],
    "Ramanathapuram": [
      "Begalur",
      "Bokaloor",
      "Kamuthi",
      "Mandapam",
      "Mudukulathur",
      "Paramakudi",
      "Ramanathapuram",
      "Rameswaram",
      "Thiruppullani",
      "Thiruvadanai"
    ],
    "Ranipet": [
      "Anaicut",
      "Arakkonam",
      "Arcot",
      "Gudiyatham",
      "Sholinghur",
      "Walajapet"
    ],
    "Salem": [
      "Attur",
      "Edappadi",
      "Gangavalli",
      "Kadayampatti",
      "Mettur",
      "Omalur",
      "Pethanaickenpalayam",
      "Salem",
      "Sankagiri",
      "Vazhapadi",
      "Yercaud"
    ],
    "Sivaganga": [
      "Devakottai",
      "Ilayangudi",
      "Kalaiyarkoil",
      "Karaikudi",
      "Manamadurai",
      "Sakkottai",
      "Singampunari",
      "Sivaganga",
      "Thiruppuvanam",
      "Thiruvadanai"
    ],
    "Tenkasi": [
      "Alangulam",
      "Idaikkattur",
      "Kadayanallur",
      "Keelapavoor",
      "Kuruvikulam",
      "Melaneelithanallur",
      "Sankarankovil",
      "Shenkottai",
      "Tenkasi",
      "Vasudevanallur",
      "Veerakeralampudur"
    ],
    "Thanjavur": [
      "Boothalur",
      "Madukkur",
      "Orathanadu",
      "Papanasam",
      "Peravurani",
      "Thanjavur",
      "Thiruvaiyaru",
      "Thiruvidaimarudur",
      "Thiruvonam"
    ],
    "Thiruvallur": [
      "Avadi",
      "Gummidipoondi",
      "Pallipattu",
      "Ponneri",
      "Poonamallee",
      "Thiruvallur",
      "Tiruttani",
      "Uthukkottai"
    ],
    "Thiruvarur": [
      "Koradacherry",
      "Kottur",
      "Kudavasal",
      "Mannargudi",
      "Nannilam",
      "Needamangalam",
      "Thiruthuraipoondi",
      "Thiruvarur",
      "Valangaiman"
    ],
    "Thiruvannamalai": [
      "Arani",
      "Chengam",
      "Cheyyar",
      "Jawadhu Hills",
      "Kalasapakkam",
      "Polur",
      "Pudupalayam",
      "Thandrampet",
      "Thirupathur",
      "Thiruvannamalai",
      "Vandavasi",
      "West Arani"
    ],
    "Tuticorin": [
      "Alwarthirunagari",
      "Ettayapuram",
      "Kayathar",
      "Kovilpatti",
      "Ottapidaram",
      "Srivaikuntam",
      "Tiruchendur",
      "Tuticorin",
      "Vilathikulam"
    ],
    "Trichirappalli": [
      "Lalgudi",
      "Manapparai",
      "Marungapuri",
      "Musiri",
      "Thottiyam",
      "Thuraiyur",
      "Trichirappalli",
      "Uppliyapuram",
      "Vaiyampatti"
    ],
    "Tirunelveli": [
      "Ambasamudram",
      "Cheranmahadevi",
      "Manur",
      "Nanguneri",
      "Papanasam",
      "Radhapuram",
      "Sankarankoil",
      "Shenkottai",
      "Thisayanvilai",
      "Tirunelveli"
    ],
    "Tirupathur": [
      "Gudiyatham",
      "Natrampalli",
      "Tirupathur",
      "Vaniyambadi"
    ],
    "Tiruppur": [
      "Avinashi",
      "Dharapuram",
      "Kangeyam",
      "Madathukulam",
      "Palladam",
      "Tiruppur",
      "Udumalaipettai",
      "Vellakoil"
    ],
    "Vellore": [
      "Anaicut",
      "Gudiyatham",
      "Kandili",
      "Kaniyambadi",
      "Katpadi",
      "Pernambut",
      "Vellore"
    ],
    "Viluppuram": [
      "Gingee",
      "Kandachipuram",
      "Melmalayanur",
      "Tindivanam",
      "Tirumalaiyur",
      "Thirukoilur",
      "Vallam",
      "Vanur",
      "Viluppuram"
    ],
    "Virudhunagar": [
      "Aruppukkottai",
      "Kariapatti",
      "Rajapalayam",
      "Sattur",
      "Sivakasi",
      "Srivilliputhur",
      "Thiruchuli",
      "Vembakottai",
      "Virudhunagar",
      "Watrap"
    ]
  },
  "Telangana": {
    "Adilabad": [
      "Adilabad",
      "Bela",
      "Bazarhathnoor",
      "Gudihathnoor",
      "Jainad",
      "Talamadugu",
      "Sirpur(U)",
      "Ichoda",
      "Narnoor",
      "Utnoor",
      "Indravelly",
      "Asifabad",
      "Kerameri",
      "Wankidi",
      "Jainoor",
      "Tiryani",
      "Rebbena",
      "Kagaznagar",
      "Sirpur(T)",
      "Chintalamanepalli",
      "Penchikalpet",
      "Bejjur",
      "Mancherial",
      "Mandamarri",
      "Luxettipet",
      "Dandepally",
      "Jaipur",
      "Bheemaram",
      "Kasipet",
      "Bellampalli",
      "Nennal",
      "Tandur",
      "Chennur",
      "Kotapalli",
      "Nirmal",
      "Nirmal Rural",
      "Dilawarpur",
      "Mamada",
      "Laxmanchanda",
      "Khanapur",
      "Kuntala",
      "Kubeer",
      "Bhainsa",
      "Tanoor",
      "Mudhole",
      "Basar",
      "Narsapur(G)",
      "Soan",
      "Sarangapur",
      "Pembi",
      "Dastరాబాద్"
    ],
    "Bhadradri Kothagudem": [
      "Bhadrachalam",
      "Cherla",
      "Dummugudem",
      "Kunavaram",
      "Velerupadu",
      "Kukkunoor",
      "Burgampahad",
      "Sattupalli",
      "Dammapeta",
      "Gundala",
      "Mulakalapalli",
      "Kothagudem",
      "Palvancha",
      "Tekulapalli",
      "Yellandu",
      "Chandrugonda",
      "Julurupadu",
      "Aswapuram",
      "Manuguru",
      "Pinapaka",
      "Allapalli",
      "Regalla",
      "Karakagudem"
    ],
    "Hyderabad": [
      "Hyderabad"
    ],
    "Jagtial": [
      "Jagtial",
      "Raikal",
      "Sarangapur",
      "Beerpur",
      "Dharmapuri",
      "Buggaram",
      "Pegadapalli",
      "Gollapalli",
      "Malyala",
      "Korutla",
      "Metpalli",
      "Mallapur",
      "Medipalli",
      "Kathlapur",
      "Ibrahimpatnam",
      "Velgatoor",
      "Ramadugu",
      "Chandurthi"
    ],
    "Jangaon": [
      "Ghanpur (Station)",
      "Jangaon",
      "Raghunathpalle",
      "Lingalaghanpur",
      "Bomraspeta",
      "Narmetta",
      "Devaruppula",
      "Kodakandla",
      "Palakurthi",
      "Chityala",
      "Bachannapet",
      "Tirumalagiri"
    ],
    "Kamareddy": [
      "Kamareddy",
      "Bhiknoor",
      "Domakonda",
      "Machareddy",
      "Sadasivanagar",
      "Yellareddy",
      "Gandhari",
      "Nagireddypet",
      "Tadwai",
      "Pitlam",
      "Banswada",
      "Birkoor",
      "Nizamsagar",
      "Erra Pahad",
      "Lingampet",
      "Jukkal",
      "Madnoor",
      "Pedda Kodapgal",
      "Rajampet",
      "Ramareddy",
      "Bibipet",
      "Nasrullabad"
    ],
    "Karimnagar": [
      "Huzurabad",
      "Jammikunta",
      "Veenavanka",
      "Elkathurthi",
      "Kamalapur",
      "Saidapur",
      "Karimnagar",
      "Thimmapur",
      "Ganneruvaram",
      "Manakondur",
      "Chigurumamidi",
      "Ellanthakunta",
      "Shankarapatnam",
      "Choppadandi",
      "Ramadugu",
      "Gambhiraopet"
    ],
    "Khammam": [
      "Kallur",
      "Tallada",
      "Penuballi",
      "Satthupalle",
      "Vemsoor",
      "Khammam",
      "Khammam Rural",
      "Mudigonda",
      "Chintakani",
      "Bonakal",
      "Madira",
      "Yerrupalem",
      "Enkuru",
      "Singareni",
      "Wyra",
      "Konijerla",
      "Nelakondapalli",
      "Thallada",
      "Kusumanchi",
      "Tirumalayapalem",
      "Karepalli"
    ],
    "Mahabubabad": [
      "Mahabubabad",
      "Gudur",
      "Kesamudram",
      "Nellikuduru",
      "Thorrur",
      "Narsimhulapet",
      "Danthalapalle",
      "Kuravi",
      "Chinthalapalle",
      "Gangaram",
      "Bayyaram",
      "Garla",
      "Dornakal",
      "Maripeda",
      "Peddavangara",
      "Kothaguda"
    ],
    "Mahbubnagar": [
      "Mahbubnagar",
      "Addakal",
      "Devarkadra",
      "Hanwada",
      "Jadcherla",
      "Koilkonda",
      "Nawabpet",
      "Farooqnagar",
      "Keshampeta",
      "Midjil",
      "Narayanpet",
      "Damaragidda",
      "Kosgi",
      "Makthal",
      "Utkoor",
      "Narva",
      "Dhanwada",
      "Marikal",
      "Maddur",
      "Nettempadu",
      "Amangal",
      "Kadthal",
      "Talakondapalli",
      "Veldanda",
      "Timmajipet",
      "Bijinapalle"
    ],
    "Medak": [
      "Medak",
      "Papannapet",
      "Shankarampet(A)",
      "Shankarampet(R)",
      "Ramayampet",
      "Chegunta",
      "Narsapur",
      "Shivampet",
      "Yeldurthy",
      "Toopran",
      "Manoharabad",
      "Kowdipally",
      "Nizampet",
      "Kulcharam",
      "Alladurg",
      "Tekmal",
      "Regode",
      "Chinna Kodur",
      "Dubbak",
      "Mirdoddi"
    ],
    "Medchal–Malkajgiri": [
      "Malkajgiri",
      "Alwal",
      "Keesara",
      "Shamirpet",
      "Medchal",
      "Uppal",
      "Balanagar",
      "Kukatpally",
      "Quthbullapur",
      "Dundigal",
      "Bachupally",
      "Ghatkesar",
      "Hayathnagar",
      "Saroornagar"
    ],
    "Mulugu": [
      "Eturunagaram",
      "Kannaigudem",
      "Mulugu",
      "Govindaraopet",
      "Venkatapur",
      "Wazeed",
      "Venkatapuram",
      "Tadvai",
      "Mangapet"
    ],
    "Nagarkurnool": [
      "Achampet",
      "Amrabad",
      "Lingal",
      "Nagarkurnool",
      "Thimmajipet",
      "Tadoor",
      "Telkapalle",
      "Vangoor",
      "Urukonada",
      "Peddakothapalle",
      "Kollapur",
      "Kodair",
      "Bijinapalle",
      "Charakonda",
      "Uppununthala",
      "Veepanagandla",
      "Wanaparthy",
      "Pangal",
      "Revally",
      "Gopalpet",
      "Madhanapur",
      "Ghanpur"
    ],
    "Nalgonda": [
      "Miryalaguda",
      "Dameracherla",
      "Garidepally",
      "Huzurnagar",
      "Kodad",
      "Mellachervu",
      "Neredcherla",
      "Chinthapally",
      "Devarakonda",
      "Chandampet",
      "Gundlapally",
      "Nampally",
      "Pedda Adiserlapally",
      "Nalgonda",
      "Thipparthi",
      "Munugode",
      "Narketpally",
      "Kattangur",
      "Shaligowraram",
      "Nakrekal",
      "Chityal",
      "Ramannapet",
      "Valigonda",
      "Mothey",
      "Turkapally",
      "Atmakur(M)",
      "Bhongir",
      "Bibinagar",
      "Pochampally",
      "Yadagirigutta",
      "Alair"
    ],
    "Narayanpet": [
      "Kodangal",
      "Bomraspeta",
      "Damaragidda",
      "Kosgi",
      "Narayanpet",
      "Dhanwada",
      "Marikal",
      "Maddur",
      "Nettempadu",
      "Makthal",
      "Utkoor"
    ],
    "Nirmal": [
      "Bhainsa",
      "Tanoor",
      "Mudhole",
      "Basar",
      "Narsapur(G)",
      "Soan",
      "Sarangapur",
      "Pembi",
      "Nirmal",
      "Nirmal Rural",
      "Dilawarpur",
      "Mamada",
      "Laxmanchanda",
      "Khanapur",
      "Kuntala",
      "Kubeer"
    ],
    "Peddapalli": [
      "Manthani",
      "Kataram",
      "Mahadevpur",
      "Mutharam(M)",
      "Malharrao",
      "Peddapalli",
      "Sultanabad",
      "Eligaid",
      "Julapalli",
      "Dharmaram",
      "Ramagiri",
      "Antargaon",
      "Srirampur",
      "Kalva Srirampur"
    ],
    "Rajanna Sircilla": [
      "Sircilla",
      "Gambhiraopet",
      "Illanthakunta",
      "Thangalapalli",
      "Vemulawada",
      "Chandurthi",
      "Konaraopeta",
      "Boinpalli",
      "Veernapalli",
      "Yellareddypeta",
      "Mustabad",
      "Gudem",
      "Warangal Rural"
    ],
    "Ranga Reddy": [
      "Ibrahimpatnam",
      "Manchal",
      "Yacharam",
      "Maheswaram",
      "Kandukur",
      "Saroornagar",
      "Shadnagar",
      "Kondurg",
      "Faroognagar",
      "Kothur",
      "Keshampet",
      "Shamshabad",
      "Rajendranagar",
      "Moinabad",
      "Chevella",
      "Shankarpalli",
      "Marpalle",
      "Vikarabad",
      "Tandur",
      "Peddemul",
      "Dharur",
      "Bantwaram",
      "Kodangal",
      "Bomraspeta",
      "Doulathabad",
      "Nawabpet",
      "Pargi"
    ],
    "Sangareddy": [
      "Sangareddy",
      "Kandi",
      "Patancheru",
      "Ramachandrapuram",
      "Jinnaram",
      "Gummadidala",
      "Pulkal",
      "Andole",
      "Munipalli",
      "Sadasivpet",
      "Zaheerabad",
      "Jharasangam",
      "Kohir",
      "Nyalkal",
      "Mogudampalle",
      "Raipole",
      "Narayankhed",
      "Manoor",
      "Sirgapoor",
      "Kalher",
      "Kangti",
      "Alladurg",
      "Tekmal",
      "Regode",
      "Papannapet",
      "Shankarampet(A)",
      "Shankarampet(R)",
      "Ramayampet",
      "Chegunta"
    ],
    "Siddipet": [
      "Husnabad",
      "Koheda",
      "Siddipet",
      "Nanganoor",
      "Chinnakodur",
      "Mirdoddi",
      "Dubbak",
      "Thoguta",
      "Doulthabad",
      "Cheriyal",
      "Maddur",
      "Komurvelly",
      "Jagadevpur",
      "Markook",
      "Mulugu",
      "Raikal",
      "Gajwel",
      "Pragnapur",
      "Wargal",
      "Kondapaka",
      "Memdal",
      "Allipur"
    ],
    "Suryapet": [
      "Kodad",
      "Chivemla",
      "Munagala",
      "Nadigudem",
      "Huzurnagar",
      "Mattampally",
      "Mellachervu",
      "Neredcherla",
      "Suryapet",
      "Chivvemla",
      "Penpahad",
      "Thirumalagiri",
      "Athmakur(S)",
      "Jajireddygudem",
      "Mothey",
      "Thungathurthy",
      "Nagaram",
      "Rajapet",
      "Yadagirigutta",
      "Alair",
      "Bhongir",
      "Bibinagar",
      "Pochampally"
    ],
    "Vikarabad": [
      "Tandur",
      "Peddemul",
      "Dharur",
      "Bantwaram",
      "Kodangal",
      "Bomraspeta",
      "Doulathabad",
      "Vikarabad",
      "Marpalle",
      "Pudur",
      "Nawabpet",
      "Pargi",
      "Moinabad",
      "Chevella",
      "Shankarpalli"
    ],
    "Wanaparthy": [
      "Gadwal",
      "Dharur",
      "Maldakal",
      "Ghattu",
      "Alampur",
      "Ieeja",
      "Itikyal",
      "Wadapally",
      "Manopad",
      "Kollapur",
      "Koderu",
      "Pangal",
      "Revally",
      "Gopalpet",
      "Madhanapur",
      "Ghanpur",
      "Nagarkurnool",
      "Thimmajipet",
      "Tadoor",
      "Telkapalle",
      "Vangoor"
    ],
    "Warangal Rural": [
      "Narsampet",
      "Chennaraopet",
      "Nallabelly",
      "Duggondi",
      "Geesugonda",
      "Parvathagiri",
      "Sangem",
      "Wardhannapet",
      "Khila Warangal",
      "Rayaparthy",
      "Atmakur",
      "Parkal",
      "Nadikuda",
      "Damera",
      "Gudur",
      "Khanapur",
      "Nekkonda",
      "Narayanagiri",
      "Chelpur",
      "Shayampet",
      "Warangal Urban",
      "Hanamkonda",
      "Kazipet",
      "Intezargunj",
      "Warangal"
    ],
    "Warangal Urban": [
      "Kazipet",
      "Hanamkonda",
      "Warangal"
    ],
    "Yadadri Bhuvanagiri": [
      "Bhuvanagiri",
      "Bibinagar",
      "Pochampally",
      "Yadagirigutta",
      "Alair",
      "Rajapet",
      "Turkapally",
      "Valigonda",
      "Ramannapet",
      "Chityala",
      "Nakrekal",
      "Kattangur",
      "Shaligowraram",
      "Thipparthi",
      "Munugode",
      "Narketpally"
    ]
  },
  "Tripura": {
    "Dhalai": ["Ambassa"],
    "Gomati": ["Udaipur"],
    "Khowai": ["Khowai"],
    "North Tripura": ["Dharmanagar", "Kanchanpur"],
    "Sepahijala": ["Bishalgarh"],
    "South Tripura": ["Belonia"],
    "Unakoti": ["Kailashahar"],
    "West Tripura": ["Agartala"]
  },
  "Uttarakhand": {
    "Almora": ["Almora", "Ranikhet"],
    "Bageshwar": ["Bageshwar", "Kapkot"],
    "Chamoli": ["Joshimath", "Karnaprayag"],
    "Champawat": ["Champawat", "Pati"],
    "Dehradun": ["Dehradun", "Vikasnagar"],
    "Haridwar": ["Haridwar", "Roorkee"],
    "Nainital": ["Nainital", "Haldwani"],
    "Pauri Garhwal": ["Pauri", "Kotdwar"],
    "Pithoragarh": ["Pithoragarh", "Dharchula"],
    "Rudraprayag": ["Rudraprayag", "Ukhimath"],
    "Tehri Garhwal": ["Tehri", "Ghansali"],
    "Udham Singh Nagar": ["Rudrapur", "Kashipur"],
    "Uttarkashi": ["Uttarkashi", "Purola"]
  },
  "Uttar Pradesh": {
    "Agra": [
      "Agra",
      "Kheragarh",
      "Fatehpur Sikri",
      "Bah",
      "Etmadpur",
      "Kirawali"
    ],
    "Aligarh": [
      "Aligarh",
      "Khair",
      "Atrauli",
      "Iglas",
      "Koil",
      "Gabhana",
      "Bijnaur"
    ],
    "Ambedkar Nagar": [
      "Akbarpur",
      "Tanda",
      "Jalalpur",
      "Bhiti",
      "Alapur"
    ],
    "Amethi": [
      "Gauriganj",
      "Musafirkhana",
      "Amethi",
      "Tiloi"
    ],
    "Amroha": [
      "Amroha",
      "Dhanaura",
      "Hasanpur",
      "Gajraula"
    ],
    "Auraiya": [
      "Auraiya",
      "Bidhuna",
      "Ajitmal"
    ],
    "Ayodhya": [
      "Ayodhya",
      "Sohawal",
      "Milkipur",
      "Rudauli",
      "Bikapur"
    ],
    "Azamgarh": [
      "Azamgarh",
      "Lalganj",
      "Martinganj",
      "Nizamabad",
      "Sadar",
      "Budhanpur",
      "Mehnagar"
    ],
    "Baghpat": [
      "Baghpat",
      "Khekra",
      "Baraut"
    ],
    "Bahraich": [
      "Bahraich",
      "Kaiserganj",
      "Nanpara",
      "Mahsi",
      "Payagpur",
      "Kataraniaghat"
    ],
    "Ballia": [
      "Ballia",
      "Rasra",
      "Bansdih",
      "Belthara Road"
    ],
    "Balrampur": [
      "Balrampur",
      "Tulsipur",
      "Utraula",
      "Gainsari"
    ],
    "Banda": [
      "Banda",
      "Atarra",
      "Baberu",
      "Naraini"
    ],
    "Barabanki": [
      "Barabanki",
      "Ramsanehighat",
      "Nawabganj",
      "Fatehpur",
      "Ramnagar",
      "Sirauli Gauspur"
    ],
    "Bareilly": [
      "Bareilly",
      "Aonla",
      "Baheri",
      "Faridpur",
      "Meerganj",
      "Nawabganj"
    ],
    "Basti": [
      "Basti",
      "Harraiya",
      "Bhanpur",
      "Rudhauli",
      "Kaptanganj"
    ],
    "Bhadohi": [
      "Gyanpur",
      "Aurai",
      "Bhadohi"
    ],
    "Bijnor": [
      "Bijnor",
      "Dhampur",
      "Najibabad",
      "Chandpur",
      "Nagina",
      "Kiratpur",
      "Syonara",
      "Amangarh"
    ],
    "Bulandshahr": [
      "Bulandshahr",
      "Sikandrabad",
      "Anupshahr",
      "Debai",
      "Khurja",
      "Shikarpur",
      "Syana"
    ],
    "Chandauli": [
      "Chandauli",
      "Sakaldiha",
      "Chakia",
      "Dhanapur"
    ],
    "Chitrakoot": [
      "Chitrakoot",
      "Karwi",
      "Mau",
      "Rajnagar"
    ],
    "Deoria": [
      "Deoria",
      "Salempur",
      "Rudrapur",
      "Barsar",
      "Gauri Bazar",
      "Rampur Karkhana"
    ],
    "Etah": [
      "Etah",
      "Jalesar",
      "Aliganj",
      "Nidhauli Kalan",
      "Sakit"
    ],
    "Etawah": [
      "Etawah",
      "Bharthana",
      "Chakarnagar",
      "Jaswantnagar"
    ],
    "Farrukhabad": [
      "Farrukhabad",
      "Kaimganj",
      "Amritpur"
    ],
    "Fatehpur": [
      "Fatehpur",
      "Bindki",
      "Khaga",
      "Husainganj",
      "Sadar"
    ],
    "Firozabad": [
      "Firozabad",
      "Shikohabad",
      "Jasrana",
      "Tundla",
      "Sirsaganj"
    ],
    "Gautam Buddh Nagar": [
      "Noida",
      "Dadri",
      "Jewar"
    ],
    "Ghaziabad": [
      "Ghaziabad",
      "Modinagar",
      "Loni",
      "Muradnagar",
      "Hapur"
    ],
    "Ghazipur": [
      "Ghazipur",
      "Muhammadabad",
      "Jakhania",
      "Saidpur",
      "Sadar",
      "Zamania"
    ],
    "Gonda": [
      "Gonda",
      "Colonelganj",
      "Tarabganj",
      "Utraula",
      "Katra Bazar",
      "Mankapur"
    ],
    "Gorakhpur": [
      "Gorakhpur",
      "Campierganj",
      "Gola",
      "Khajni",
      "Sahjanwa",
      "Bansgaon"
    ],
    "Hamirpur": [
      "Hamirpur",
      "Maudaha",
      "Rath"
    ],
    "Hapur": [
      "Hapur",
      "GarhmuKteshwar",
      "Dhaulana"
    ],
    "Hardoi": [
      "Hardoi",
      "Shahabad",
      "Sandi",
      "Sawayajpur",
      "Bilgram",
      "Pali",
      "Shahabad"
    ],
    "Hathras": [
      "Hathras",
      "Sikandra Rao",
      "Sadabad",
      "Sasni"
    ],
    "Jalaun": [
      "Orai",
      "Kalpi",
      "Madhogarh",
      "Konch"
    ],
    "Jaunpur": [
      "Jaunpur",
      "Machhlishahr",
      "Badlapur",
      "Kerakat",
      "Mariyahu",
      "Shahganj",
      "Machhali Shahar"
    ],
    "Jhansi": [
      "Jhansi",
      "Mauranipur",
      "Garautha",
      "Moth"
    ],
    "Kannauj": [
      "Kannauj",
      "Chhibramau",
      "Tirwa"
    ],
    "Kanpur Dehat": [
      "Akbarpur",
      "Sikandra",
      "Derapur",
      "Rasoolabad"
    ],
    "Kanpur Nagar": [
      "Kanpur",
      "Bilhaur",
      "Ghatampur",
      "Narwal"
    ],
    "Kasganj": [
      "Kasganj",
      "Patiyali",
      "Sahar"
    ],
    "Kaushambi": [
      "Manjhanpur",
      "Chail",
      "Sirathu"
    ],
    "Kushinagar": [
      "Padrauna",
      "Hata",
      "Tamkuhi Raj",
      "Kasia"
    ],
    "Lakhimpur Kheri": [
      "Kheri",
      "Mohammadi",
      "Gola Gokaran Nath",
      "Nighasan",
      "Dhaurahra",
      "Palia"
    ],
    "Lalitpur": [
      "Lalitpur",
      "Mahroni",
      "Talbehat"
    ],
    "Lucknow": [
      "Lucknow",
      "Mahilabad",
      "Malihabad",
      "Bakshi Ka Talab",
      "Mohanlalganj"
    ],
    "Maharajganj": [
      "Maharajganj Sadar",
      "Nautanwa",
      "Nichlaul"
    ],
    "Mainpuri": [
      "Mainpuri",
      "Bhogaon",
      "Karhal",
      "Kishni",
      "Ghiror",
      "Kurawali"
    ],
    "Mathura": [
      "Mathura",
      "Chhata",
      "Mant",
      "Gokul",
      "Mahaban",
      "Baldeo"
    ],
    "Mau": [
      "Ghosi",
      "Madhuban",
      "Maunath Bhanjan",
      "Muhammadabad Gohna"
    ],
    "Meerut": [
      "Meerut",
      "Mawana",
      "Hapur",
      "Sardhana"
    ],
    "Mirzapur": [
      "Mirzapur",
      "Chunar",
      "Lalganj",
      "Marihan",
      "Sadar"
    ],
    "Moradabad": [
      "Moradabad",
      "Bilari",
      "Kanth",
      "Thakurdwara"
    ],
    "Muzaffarnagar": [
      "Muzaffarnagar",
      "Jansath",
      "Budhana",
      "Khatauli"
    ],
    "Pilibhit": [
      "Pilibhit",
      "Puranpur",
      "Bisalpur",
      "Amaria",
      "Kalinagar"
    ],
    "Pratapgarh": [
      "Pratapgarh",
      "Patti",
      "Lalganj",
      "Kunda",
      "Raniganj"
    ],
    "Prayagraj": [
      "Karchhana",
      "Koraon",
      "Phulpur",
      "Bara",
      "Meja",
      "Sadar",
      "Soraon",
      "Handia"
    ],
    "Raebareli": [
      "Raebareli",
      "Lalganj",
      "Dalmau",
      "Unchahar",
      "Maharajganj",
      "Salon"
    ],
    "Rampur": [
      "Rampur",
      "Shahabad",
      "Bilaspur",
      "Milak"
    ],
    "Saharanpur": [
      "Saharanpur",
      "Deoband",
      "Nakur",
      "Rampur Maniharan"
    ],
    "Sambhal": [
      "Sambhal",
      "Chandausi",
      "Gunnaur",
      "Bahjoi"
    ],
    "Sant Kabir Nagar": [
      "Khalilabad",
      "Mehdawal",
      "Dhanghata",
      "Semariyawan",
      "Hainsarbazar"
    ],
    "Shahjahanpur": [
      "Shahjahanpur",
      "Tilhar",
      "Jalalabad",
      "Powayan",
      "Nigohi"
    ],
    "Shamli": [
      "Shamli",
      "Kandhla",
      "Thana Bhawan",
      "Oon"
    ],
    "Shravasti": [
      "Bhinga",
      "Ikauna",
      "Sirsiya"
    ],
    "Siddharthnagar": [
      "Naugarh",
      "Shohratgarh",
      "Kapilvastu",
      "Bansi",
      "Itwa"
    ],
    "Sitapur": [
      "Sitapur",
      "Biswan",
      "Laharpur",
      "Maholi",
      "Misrikh",
      "Sidhauli"
    ],
    "Sonbhadra": [
      "Robertsganj",
      "Ghorawal",
      "Dudhi",
      "Chopan"
    ],
    "Sultanpur": [
      "Sultanpur",
      "Lambhua",
      "Kadipur",
      "Musafirkhana"
    ],
    "Unnao": [
      "Unnao",
      "Safipur",
      "Hasanganj",
      "Purwa",
      "Bighapur"
    ],
    "Varanasi": [
      "Varanasi",
      "Pindra",
      "Chiraigaon",
      "Kolsala",
      "Rajatalab"
    ]
  }

};

export default talukasByState;
